/* eslint-disable */
// ─────────────────────────────────────────────────────────────────────────────
// CrmIncorporadoras.jsx — Página "CRM para Incorporadoras" IMOBMEET
// Transcrição fiel do bundle de produção (imobmeet-site.netlify.app).
// Estrutura, estilos inline, classNames e animações reproduzidos verbatim a
// partir do código real des-minificado, preservando o runtime jsx do React.
// Navbar e Footer são os componentes compartilhados do projeto.
// ─────────────────────────────────────────────────────────────────────────────
import * as b from "react";
import * as n from "react/jsx-runtime";
import { Link as V } from "react-router-dom";
import { C, font, mono } from "../tokens";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { applySeo } from "../lib/seo";
import { setFaqSchema, clearFaqSchema } from "../lib/faqSchema";

// Aliases dos identificadores do bundle original.
const s = C, p = font, Pt = mono;
const _n = Navbar;   // Navbar compartilhada
const Hn = Footer;   // Footer compartilhado
const qn = () => null; // banner de cookies / botão WhatsApp (globais em App.jsx)

// ── Componentes e dados compartilhados (idênticos aos de Home.jsx) ───────────
function ki({
    videoId: e,
    open: t,
    onClose: r,
    title: o = "Vídeo",
    subtitle: i = "IMOBMEET CRM"
}) {
    return b.useEffect(() => {
        if (!t) return;
        const a = d => {
            d.key === "Escape" && r()
        };
        document.addEventListener("keydown", a);
        const l = document.body.style.overflow;
        return document.body.style.overflow = "hidden", () => {
            document.removeEventListener("keydown", a), document.body.style.overflow = l
        }
    }, [t, r]), t ? n.jsx("div", {
        onClick: r,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": o,
        style: {
            position: "fixed",
            inset: 0,
            zIndex: 200,
            background: "rgba(5,9,23,0.82)",
            backdropFilter: "blur(6px)",
            WebkitBackdropFilter: "blur(6px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
            animation: "notif-in 0.22s cubic-bezier(.16,1,.3,1) both"
        },
        children: n.jsxs("div", {
            onClick: a => a.stopPropagation(),
            style: {
                width: "100%",
                maxWidth: 980,
                borderRadius: 18,
                overflow: "hidden",
                background: "#0B1330",
                border: "1px solid rgba(255,255,255,0.12)",
                boxShadow: "0 40px 100px rgba(0,0,0,0.6)"
            },
            children: [n.jsxs("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: 13,
                    padding: "14px 16px 14px 18px",
                    borderBottom: "1px solid rgba(255,255,255,0.08)",
                    background: "linear-gradient(180deg, rgba(255,255,255,0.05), rgba(255,255,255,0))"
                },
                children: [n.jsx("span", {
                    style: {
                        width: 38,
                        height: 38,
                        borderRadius: 11,
                        flexShrink: 0,
                        background: "linear-gradient(135deg, #2C6BFF 0%, #0560FF 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 6px 16px rgba(5,96,255,0.4)"
                    },
                    children: n.jsxs("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "#fff",
                        strokeWidth: "1.9",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: [n.jsx("rect", {
                            x: "3",
                            y: "4",
                            width: "18",
                            height: "12",
                            rx: "2"
                        }), n.jsx("path", {
                            d: "M2 20h20"
                        }), n.jsx("path", {
                            d: "M10 8.5 14.5 11 10 13.5z",
                            fill: "#fff",
                            stroke: "none"
                        })]
                    })
                }), n.jsxs("div", {
                    style: {
                        flex: 1,
                        minWidth: 0
                    },
                    children: [n.jsx("div", {
                        style: {
                            fontFamily: p,
                            fontSize: 16,
                            fontWeight: 800,
                            color: "#fff",
                            letterSpacing: -.3,
                            lineHeight: 1.2
                        },
                        children: o
                    }), i && n.jsx("div", {
                        style: {
                            fontFamily: p,
                            fontSize: 12.5,
                            color: "rgba(255,255,255,0.55)",
                            marginTop: 1
                        },
                        children: i
                    })]
                }), n.jsx("button", {
                    onClick: r,
                    "aria-label": "Fechar vídeo",
                    style: {
                        width: 38,
                        height: 38,
                        borderRadius: 10,
                        flexShrink: 0,
                        background: "rgba(255,255,255,0.10)",
                        border: "1px solid rgba(255,255,255,0.18)",
                        color: "white",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "background 0.2s"
                    },
                    onMouseEnter: a => a.currentTarget.style.background = "rgba(255,255,255,0.2)",
                    onMouseLeave: a => a.currentTarget.style.background = "rgba(255,255,255,0.1)",
                    children: n.jsx("svg", {
                        width: "17",
                        height: "17",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "2.4",
                        strokeLinecap: "round",
                        children: n.jsx("path", {
                            d: "M18 6 6 18M6 6l12 12"
                        })
                    })
                })]
            }), n.jsxs("div", {
                style: {
                    position: "relative",
                    paddingTop: "56.25%",
                    background: "#000"
                },
                children: [n.jsx("iframe", {
                    src: `https://www.youtube-nocookie.com/embed/${e}?autoplay=1&rel=0&modestbranding=1&iv_load_policy=3&playsinline=1&fs=1`,
                    title: o,
                    allow: "autoplay; encrypted-media; picture-in-picture; web-share",
                    allowFullScreen: !0,
                    style: {
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        border: 0
                    }
                }), n.jsx("div", {
                    "aria-hidden": "true",
                    onClick: a => a.preventDefault(),
                    style: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        height: "18%",
                        zIndex: 2,
                        cursor: "default"
                    }
                })]
            }), n.jsxs("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 14,
                    flexWrap: "wrap",
                    padding: "15px 18px",
                    borderTop: "1px solid rgba(255,255,255,0.08)",
                    background: "linear-gradient(0deg, rgba(255,255,255,0.05), rgba(255,255,255,0))"
                },
                children: [n.jsx("span", {
                    style: {
                        fontFamily: p,
                        fontSize: 13.5,
                        color: "rgba(255,255,255,0.7)",
                        lineHeight: 1.4
                    },
                    children: "Quer ver aplicado à sua operação?"
                }), n.jsxs(V, {
                    to: "/agendar-demo",
                    onClick: r,
                    style: {
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 9,
                        padding: "12px 22px",
                        borderRadius: 11,
                        textDecoration: "none",
                        background: "linear-gradient(135deg, #2C6BFF 0%, #0560FF 100%)",
                        color: "#fff",
                        fontFamily: p,
                        fontSize: 14.5,
                        fontWeight: 800,
                        letterSpacing: .2,
                        boxShadow: "0 10px 24px rgba(5,96,255,0.4)",
                        transition: "transform 0.2s, box-shadow 0.2s"
                    },
                    onMouseEnter: a => {
                        a.currentTarget.style.transform = "translateY(-2px)", a.currentTarget.style.boxShadow = "0 14px 30px rgba(5,96,255,0.5)"
                    },
                    onMouseLeave: a => {
                        a.currentTarget.style.transform = "none", a.currentTarget.style.boxShadow = "0 10px 24px rgba(5,96,255,0.4)"
                    },
                    children: ["Falar com vendas", n.jsx("svg", {
                        width: "16",
                        height: "16",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "2.4",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: n.jsx("path", {
                            d: "M5 12h14M13 6l6 6-6 6"
                        })
                    })]
                })]
            })]
        })
    }) : null
}

const     cn = e => n.jsx("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: e
    }),
    il = [{
        label: "CRM para Incorporadoras",
        to: "/crm-incorporadoras",
        desc: "Gestão completa de empreendimentos verticais — torres, andares e tipologias.",
        bg: "linear-gradient(135deg, #0560FF 0%, #204493 100%)",
        color: "#0560FF",
        icon: cn(n.jsxs(n.Fragment, {
            children: [n.jsx("rect", {
                x: "5",
                y: "3",
                width: "14",
                height: "18",
                rx: "1.5"
            }), n.jsx("path", {
                d: "M9 7h.01M12 7h.01M15 7h.01M9 11h.01M12 11h.01M15 11h.01M9 15h.01M12 15h.01M15 15h.01"
            }), n.jsx("path", {
                d: "M10 21v-3h4v3"
            })]
        }))
    }, {
        label: "CRM para Loteadoras",
        to: "/crm-loteadoras",
        desc: "Do primeiro lead ao contrato em loteamentos com mapa humanizado.",
        bg: "linear-gradient(135deg, #10B981 0%, #047857 100%)",
        color: "#10B981",
        icon: cn(n.jsxs(n.Fragment, {
            children: [n.jsx("path", {
                d: "M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2z"
            }), n.jsx("path", {
                d: "M9 4v14M15 6v14"
            })]
        }))
    }, {
        label: "Pagadoria inteligente",
        to: "/split-comissoes",
        desc: "Particionamento automático da comissão por venda, com repasse automático via split.",
        bg: "linear-gradient(135deg, #8B5CF6 0%, #6D28D9 100%)",
        color: "#8B5CF6",
        icon: cn(n.jsxs(n.Fragment, {
            children: [n.jsx("circle", {
                cx: "6",
                cy: "6",
                r: "3"
            }), n.jsx("circle", {
                cx: "6",
                cy: "18",
                r: "3"
            }), n.jsx("circle", {
                cx: "18",
                cy: "12",
                r: "3"
            }), n.jsx("path", {
                d: "M9 6h3a3 3 0 0 1 3 3v0M9 18h3a3 3 0 0 0 3-3v0"
            })]
        }))
    }, {
        label: "Gestão de Recebíveis",
        to: "/gestao-de-recebiveis",
        desc: "Boletos, régua de cobrança no WhatsApp e fluxo de caixa previsível.",
        bg: "linear-gradient(135deg, #F59E0B 0%, #B45309 100%)",
        color: "#F59E0B",
        icon: cn(n.jsxs(n.Fragment, {
            children: [n.jsx("path", {
                d: "M4 2v20l2.5-1.5L9 22l3-1.5L15 22l2.5-1.5L20 22V2l-2.5 1.5L15 2l-3 1.5L9 2 6.5 3.5 4 2z"
            }), n.jsx("path", {
                d: "M8 8h8M8 12h8M8 16h5"
            })]
        }))
    }, {
        label: "Imobmeet Autovendas",
        to: "/autovendas",
        desc: "Venda 24h com seleção de unidade e pagamento via PIX ou cartão.",
        bg: "linear-gradient(135deg, #EC4899 0%, #BE185D 100%)",
        color: "#EC4899",
        icon: cn(n.jsx(n.Fragment, {
            children: n.jsx("path", {
                d: "M13 2 3 14h7l-1 8 10-12h-7l1-8z"
            })
        }))
    }, {
        label: "HUB Whatsapp",
        to: "/funcionalidades/hub-whatsapp",
        desc: "Atendimento e disparos no WhatsApp multi-corretor, centralizados e com IA.",
        bg: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
        color: "#25D366",
        icon: cn(n.jsx("path", {
            d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
        }))
    }];

function O({
    children: e,
    light: t = !1,
    style: r = {}
}) {
    return n.jsx("h2", {
        style: {
            fontFamily: p,
            fontSize: 42,
            fontWeight: 800,
            lineHeight: 1.08,
            letterSpacing: -1.4,
            color: t ? "white" : s.text,
            margin: 0,
            ...r
        },
        children: e
    })
}

function se({
    children: e,
    primary: t = !0,
    href: r,
    to: o,
    style: i = {}
}) {
    const a = {
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            padding: "13px 22px",
            borderRadius: 11,
            fontSize: 14,
            fontWeight: 700,
            textDecoration: "none",
            fontFamily: p,
            cursor: "pointer"
        },
        l = {
            ...a,
            background: s.accent,
            color: "white",
            border: "1.5px solid transparent",
            boxShadow: "0 8px 24px rgba(5,96,255,0.28), inset 0 1px 0 rgba(255,255,255,0.18)",
            ...i
        },
        d = {
            ...a,
            background: s.surface,
            color: s.primary,
            border: `1.5px solid ${s.primary}`,
            ...i
        },
        c = t ? n.jsxs("span", {
            style: {
                position: "relative",
                zIndex: 1,
                display: "inline-flex",
                alignItems: "center",
                gap: 8
            },
            children: [e, " ", n.jsx("span", {
                className: "arrow",
                children: "→"
            })]
        }) : e,
        u = t ? "cta-primary" : "cta-secondary",
        m = t ? l : d;
    return o ? n.jsx(V, {
        to: o,
        className: u,
        style: m,
        children: c
    }) : n.jsx("a", {
        href: r || "#",
        className: u,
        style: m,
        children: c
    })
}

function k({
    children: e,
    delay: t = 0,
    as: r = "div",
    style: o = {},
    className: i = "",
    ...a
}) {
    const l = b.useRef(null);
    b.useEffect(() => {
        const c = l.current;
        if (!c) return;
        const u = new IntersectionObserver(([m]) => {
            m.isIntersecting && (c.classList.add("is-in"), u.disconnect())
        }, {
            threshold: .12,
            rootMargin: "0px 0px -8% 0px"
        });
        return u.observe(c), () => u.disconnect()
    }, []);
    const d = t ? ` delay-${t}` : "";
    return n.jsx(r, {
        ref: l,
        className: `reveal${d} ${i}`,
        style: o,
        ...a,
        children: e
    })
}

function ft({
    logos: e,
    height: t = 44,
    gap: r = 80,
    mono: o = !0
}) {
    const i = !!s.isDark,
        a = o ? i ? "brightness(0) invert(1)" : "brightness(0)" : "none",
        l = [...e, ...e];
    return n.jsx("div", {
        className: "logo-marquee",
        children: n.jsx("div", {
            className: "logo-track",
            style: {
                gap: r
            },
            children: l.map((d, c) => n.jsx("div", {
                className: "logo-item",
                style: {
                    height: t,
                    opacity: o ? i ? .55 : .48 : 1,
                    filter: a
                },
                children: n.jsx("img", {
                    src: d,
                    alt: "Logo de empresa que usa o IMOBMEET",
                    style: {
                        height: "100%",
                        width: "auto",
                        objectFit: "contain",
                        maxWidth: 180
                    }
                })
            }, c))
        })
    })
}

function c0({
    words: e,
    interval: t = 2400
}) {
    const [r, o] = b.useState(0);
    return b.useEffect(() => {
        const i = setInterval(() => o(a => (a + 1) % e.length), t);
        return () => clearInterval(i)
    }, [e.length, t]), n.jsxs("span", {
        style: {
            display: "inline-block",
            position: "relative",
            verticalAlign: "baseline",
            whiteSpace: "nowrap",
            overflow: "visible",
            lineHeight: 1.2,
            padding: "0.1em 0.08em 0.24em"
        },
        children: [n.jsx("span", {
            "aria-hidden": "true",
            style: {
                visibility: "hidden",
                display: "inline-block",
                whiteSpace: "nowrap"
            },
            children: e[r]
        }), e.map((i, a) => n.jsx("span", {
            style: {
                position: "absolute",
                left: 0,
                right: 0,
                top: "0.1em",
                bottom: "0.24em",
                textAlign: "center",
                opacity: a === r ? 1 : 0,
                transform: a === r ? "translateY(0)" : a < r ? "translateY(-18%)" : "translateY(18%)",
                transition: "opacity 0.5s, transform 0.6s cubic-bezier(.16,1,.3,1)",
                background: "linear-gradient(120deg, #9CC8FF 0%, #5BA4FF 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                whiteSpace: "nowrap",
                filter: "drop-shadow(0 2px 14px rgba(20,80,200,0.35))"
            },
            children: i
        }, a))]
    })
}

function Si({
    src: e,
    alt: t = "",
    ratio: r = "3 / 4",
    radius: o = 22,
    style: i = {}
}) {
    return n.jsxs("div", {
        style: {
            position: "relative",
            width: "100%",
            aspectRatio: r,
            borderRadius: o,
            overflow: "hidden",
            background: `linear-gradient(160deg, ${s.accent} 0%, ${s.primary} 100%)`,
            boxShadow: "0 24px 60px rgba(5,96,255,0.22)",
            ...i
        },
        children: [n.jsx("div", {
            style: {
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "rgba(255,255,255,0.45)"
            },
            children: n.jsxs("svg", {
                width: "84",
                height: "84",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "1.3",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: [n.jsx("circle", {
                    cx: "12",
                    cy: "8",
                    r: "4"
                }), n.jsx("path", {
                    d: "M4 21c0-4 3.6-7 8-7s8 3 8 7"
                })]
            })
        }), e && n.jsx("img", {
            src: e,
            alt: t,
            loading: "lazy",
            onError: a => {
                a.currentTarget.style.display = "none"
            },
            style: {
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover"
            }
        })]
    })
}

const it = e => n.jsx("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: e
});

function Rd({
    icon: e,
    children: t
}) {
    return n.jsxs("div", {
        style: {
            display: "inline-flex",
            alignItems: "center",
            gap: 9,
            background: "#FFFFFF",
            border: `1px solid ${s.border}`,
            borderRadius: 12,
            padding: "6px 15px 6px 6px",
            boxShadow: "0 6px 16px rgba(5,96,255,0.08)"
        },
        children: [n.jsx("span", {
            style: {
                width: 28,
                height: 28,
                borderRadius: 8,
                flexShrink: 0,
                background: `linear-gradient(135deg, ${s.accent} 0%, ${s.primary} 100%)`,
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 10px rgba(5,96,255,0.3)"
            },
            children: e
        }), n.jsx("span", {
            style: {
                fontFamily: p,
                fontSize: 12.5,
                fontWeight: 800,
                color: s.text,
                letterSpacing: -.1
            },
            children: t
        })]
    })
}
const u0 = n.jsxs("svg", {
        width: "15",
        height: "15",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [n.jsx("path", {
            d: "M10.5 13.5a5 5 0 0 0 7 0l2.5-2.5a5 5 0 0 0-7-7L11.5 5.5"
        }), n.jsx("path", {
            d: "M13.5 10.5a5 5 0 0 0-7 0L4 13a5 5 0 0 0 7 7l1.5-1.5"
        })]
    }),
    p0 = n.jsx("svg", {
        width: "15",
        height: "15",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: n.jsx("path", {
            d: "M3 21h18M5 10h14M12 3 5 8h14zM6 10v8M10 10v8M14 10v8M18 10v8"
        })
    }),
    h0 = [{
        name: "Facebook Ads",
        color: "#1877F2",
        icon: it(n.jsxs(n.Fragment, {
            children: [n.jsx("path", {
                d: "M3 11l13-6v14L3 13"
            }), n.jsx("path", {
                d: "M3 11H2.5v2H3"
            }), n.jsx("path", {
                d: "M8 14v2.5a2 2 0 0 0 4 0"
            })]
        }))
    }, {
        name: "Landing Page",
        color: "#0560FF",
        icon: it(n.jsxs(n.Fragment, {
            children: [n.jsx("rect", {
                x: "3",
                y: "4",
                width: "18",
                height: "16",
                rx: "2"
            }), n.jsx("path", {
                d: "M3 9h18"
            }), n.jsx("path", {
                d: "M7 14h7"
            })]
        }))
    }, {
        name: "WhatsApp",
        color: "#25D366",
        icon: it(n.jsx("path", {
            d: "M21 11.5a8.5 8.5 0 0 1-12.6 7.4L3 21l2.2-5.3A8.5 8.5 0 1 1 21 11.5z"
        }))
    }, {
        name: "Chat",
        color: "#7C3AED",
        icon: it(n.jsx("path", {
            d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
        }))
    }, {
        name: "Inteligência Artificial",
        color: "#0EA5E9",
        icon: it(n.jsx("path", {
            d: "M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z"
        }))
    }, {
        name: "Ligação",
        color: "#F59E0B",
        icon: it(n.jsx("path", {
            d: "M22 16.9v2.5a2 2 0 0 1-2.2 2 19.5 19.5 0 0 1-8.5-3 19.2 19.2 0 0 1-6-6 19.5 19.5 0 0 1-3-8.6A2 2 0 0 1 4.1 2H6.6a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.4 2.1L7.7 9.4a16 16 0 0 0 6 6l1-1.1a2 2 0 0 1 2.1-.4c.8.3 1.7.5 2.6.6a2 2 0 0 1 1.7 2z"
        }))
    }, {
        name: "SMS",
        color: "#EC4899",
        icon: it(n.jsxs(n.Fragment, {
            children: [n.jsx("rect", {
                x: "3",
                y: "5",
                width: "18",
                height: "14",
                rx: "2"
            }), n.jsx("path", {
                d: "M8 12h.01M12 12h.01M16 12h.01"
            })]
        }))
    }, {
        name: "E-mail",
        color: "#EF4444",
        icon: it(n.jsxs(n.Fragment, {
            children: [n.jsx("rect", {
                x: "3",
                y: "5",
                width: "18",
                height: "14",
                rx: "2"
            }), n.jsx("path", {
                d: "m3 7 9 6 9-6"
            })]
        }))
    }, {
        name: "Videoconferência",
        color: "#10B981",
        icon: it(n.jsxs(n.Fragment, {
            children: [n.jsx("rect", {
                x: "2",
                y: "6",
                width: "14",
                height: "12",
                rx: "2"
            }), n.jsx("path", {
                d: "m16 10 6-3v10l-6-3z"
            })]
        }))
    }],
    g0 = ["Atendimento omnichannel", "Distribuição e gestão de leads", "Qualificação com I.A", "Reserva", "Proposta", "Auto vendas", "Pagamentos", "Assinatura Digital", "Gestão de Recebíveis", "Integração ERP"],
    f0 = ["itau", "bradesco", "santander", "btg", "caixa", "brb", "inter", "safra", "sicredi", "sicoob"].map(e => `/assets/banks/${e}.png`),
    m0 = ["sienge", "uau", "totvs", "mega", "hubspot", "rd-station", "facebook-ads", "clicksign", "whatsapp", "zapier"].map(e => `/assets/integ/${e}.png`),
    Id = ["São Paulo", "Rio de Janeiro", "Goiânia", "Brasília", "Belo Horizonte", "Curitiba", "Campinas", "Fortaleza", "Salvador", "Porto Alegre", "Florianópolis", "Recife", "Maringá", "Uberlândia", "Sorocaba", "Londrina"],
    x0 = [{
        i: "RA",
        bg: "linear-gradient(135deg,#0560FF,#7C3AED)",
        photo: "https://randomuser.me/api/portraits/men/32.jpg"
    }, {
        i: "MC",
        bg: "linear-gradient(135deg,#10B981,#0560FF)",
        photo: "https://randomuser.me/api/portraits/women/44.jpg"
    }, {
        i: "AS",
        bg: "linear-gradient(135deg,#F59E0B,#EF4444)",
        photo: "https://randomuser.me/api/portraits/men/52.jpg"
    }, {
        i: "LP",
        bg: "linear-gradient(135deg,#7C3AED,#03D4FF)",
        photo: "https://randomuser.me/api/portraits/women/68.jpg"
    }, {
        i: "JS",
        bg: "linear-gradient(135deg,#0EA5E9,#0560FF)",
        photo: "https://randomuser.me/api/portraits/men/76.jpg"
    }, {
        i: "PM",
        bg: "linear-gradient(135deg,#EC4899,#7C3AED)",
        photo: "https://randomuser.me/api/portraits/women/12.jpg"
    }],
    y0 = n.jsxs("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [n.jsx("path", {
            d: "M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"
        }), n.jsx("circle", {
            cx: "12",
            cy: "10",
            r: "2.6"
        })]
    });

function v0() {
    return n.jsx("div", {
        style: {
            position: "absolute",
            top: -30,
            right: -16,
            zIndex: 3,
            animation: "float-y 4s ease-in-out infinite"
        },
        children: n.jsxs("svg", {
            width: "74",
            height: "74",
            viewBox: "0 0 64 64",
            fill: "none",
            style: {
                filter: "drop-shadow(0 10px 18px rgba(5,96,255,0.35))"
            },
            children: [n.jsx("defs", {
                children: n.jsxs("linearGradient", {
                    id: "robo-body",
                    x1: "0",
                    y1: "0",
                    x2: "0",
                    y2: "1",
                    children: [n.jsx("stop", {
                        offset: "0%",
                        stopColor: "#FFFFFF"
                    }), n.jsx("stop", {
                        offset: "100%",
                        stopColor: "#EAF1FF"
                    })]
                })
            }), n.jsx("line", {
                x1: "32",
                y1: "6",
                x2: "32",
                y2: "14",
                stroke: "#0560FF",
                strokeWidth: "2.4",
                strokeLinecap: "round"
            }), n.jsx("circle", {
                cx: "32",
                cy: "5",
                r: "3.2",
                fill: "#03D4FF"
            }), n.jsx("rect", {
                x: "8",
                y: "28",
                width: "6",
                height: "12",
                rx: "3",
                fill: "#0560FF"
            }), n.jsx("rect", {
                x: "50",
                y: "28",
                width: "6",
                height: "12",
                rx: "3",
                fill: "#0560FF"
            }), n.jsx("rect", {
                x: "13",
                y: "13",
                width: "38",
                height: "36",
                rx: "13",
                fill: "url(#robo-body)",
                stroke: "#0560FF",
                strokeWidth: "2.4"
            }), n.jsx("rect", {
                x: "18",
                y: "20",
                width: "28",
                height: "20",
                rx: "9",
                fill: "#0A1230"
            }), n.jsx("circle", {
                cx: "26",
                cy: "30",
                r: "3.2",
                fill: "#03D4FF",
                children: n.jsx("animate", {
                    attributeName: "r",
                    values: "3.2;0.6;3.2",
                    dur: "4s",
                    repeatCount: "indefinite",
                    begin: "2s"
                })
            }), n.jsx("circle", {
                cx: "38",
                cy: "30",
                r: "3.2",
                fill: "#03D4FF",
                children: n.jsx("animate", {
                    attributeName: "r",
                    values: "3.2;0.6;3.2",
                    dur: "4s",
                    repeatCount: "indefinite",
                    begin: "2s"
                })
            }), n.jsx("path", {
                d: "M27 35.5q5 3 10 0",
                stroke: "#03D4FF",
                strokeWidth: "1.6",
                strokeLinecap: "round",
                fill: "none",
                opacity: "0.7"
            })]
        })
    })
}

function Td({
    dir: e = "in"
}) {
    const a = [44, 110, 176].map(d => e === "in" ? `M2,${d} C${104*.55},${d} ${104*.45},110 102,110` : `M2,110 C${104*.55},110 ${104*.45},${d} 102,${d}`),
        l = `flowgrad-${e}`;
    return n.jsx("div", {
        className: "flow-connector",
        style: {
            flex: "0 0 auto",
            width: 104,
            alignSelf: "center"
        },
        children: n.jsxs("svg", {
            width: 104,
            height: 220,
            viewBox: "0 0 104 220",
            style: {
                display: "block",
                overflow: "visible"
            },
            children: [n.jsx("defs", {
                children: n.jsxs("linearGradient", {
                    id: l,
                    x1: "0",
                    y1: "0",
                    x2: "1",
                    y2: "0",
                    children: [n.jsx("stop", {
                        offset: "0%",
                        stopColor: s.accent,
                        stopOpacity: "0.12"
                    }), n.jsx("stop", {
                        offset: "100%",
                        stopColor: s.accent,
                        stopOpacity: "0.85"
                    })]
                })
            }), a.map((d, c) => n.jsxs("g", {
                children: [n.jsx("path", {
                    d,
                    fill: "none",
                    stroke: `url(#${l})`,
                    strokeWidth: "2.5",
                    strokeLinecap: "round"
                }), n.jsx("path", {
                    d,
                    fill: "none",
                    stroke: s.accent,
                    strokeWidth: "2.5",
                    strokeLinecap: "round",
                    strokeDasharray: "2 14",
                    style: {
                        animation: "flow-dash 1s linear infinite",
                        opacity: .7
                    }
                }), n.jsx("circle", {
                    r: "3.6",
                    fill: s.accent,
                    style: {
                        filter: `drop-shadow(0 0 4px ${s.accent})`
                    },
                    children: n.jsx("animateMotion", {
                        dur: "2.6s",
                        begin: `${c*.6}s`,
                        repeatCount: "indefinite",
                        path: d
                    })
                })]
            }, c))]
        })
    })
}
const Wd = {
    flex: "1 1 300px",
    minWidth: 264,
    background: s.surface,
    border: `1px solid ${s.border}`,
    borderRadius: 22,
    padding: 26,
    boxShadow: "0 16px 40px rgba(10,15,30,0.06)"
};
s.muted;

function j0() {
    return n.jsxs("section", {
        style: {
            position: "relative",
            overflow: "hidden",
            background: `linear-gradient(180deg, ${s.surface} 0%, ${s.bgAlt} 100%)`,
            padding: "100px 28px"
        },
        children: [n.jsx("div", {
            style: {
                position: "absolute",
                top: 40,
                left: "8%",
                width: 420,
                height: 420,
                borderRadius: "50%",
                background: `radial-gradient(circle, ${s.accent}14, transparent 70%)`,
                filter: "blur(30px)",
                pointerEvents: "none"
            }
        }), n.jsx("div", {
            style: {
                position: "absolute",
                bottom: -60,
                right: "6%",
                width: 460,
                height: 460,
                borderRadius: "50%",
                background: `radial-gradient(circle, ${s.primary}12, transparent 70%)`,
                filter: "blur(30px)",
                pointerEvents: "none"
            }
        }), n.jsxs("div", {
            style: {
                maxWidth: 1260,
                margin: "0 auto",
                position: "relative"
            },
            children: [n.jsx(k, {
                children: n.jsxs("div", {
                    style: {
                        textAlign: "center",
                        maxWidth: 820,
                        margin: "0 auto 56px"
                    },
                    children: [n.jsx(O, {
                        style: {
                            marginBottom: 14
                        },
                        children: "Sua máquina de gestão e vendas em um único lugar"
                    }), n.jsx("p", {
                        style: {
                            fontFamily: p,
                            fontSize: 17,
                            lineHeight: 1.65,
                            color: s.muted,
                            margin: 0
                        },
                        children: "Da captação do lead, qualificação automática com inteligência artificial, espelho de vendas, reserva, proposta, assinatura digital, integração bancária, emissão de boleto e gestão de recebíveis."
                    })]
                })
            }), n.jsx(k, {
                delay: 1,
                children: n.jsxs("div", {
                    style: {
                        display: "flex",
                        alignItems: "stretch",
                        justifyContent: "center",
                        gap: 4,
                        flexWrap: "wrap"
                    },
                    children: [n.jsxs("div", {
                        style: {
                            ...Wd,
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: [n.jsx("div", {
                            style: {
                                display: "grid",
                                gridTemplateColumns: "repeat(3, 1fr)",
                                gap: 10
                            },
                            children: h0.map((e, t) => n.jsxs("div", {
                                title: e.name,
                                className: "flow-chip",
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: 7,
                                    padding: "13px 6px",
                                    borderRadius: 13,
                                    background: s.surface,
                                    border: `1px solid ${s.border}`,
                                    textAlign: "center",
                                    animation: `float-y ${3.6+t%3*.3}s ease-in-out ${t*.12}s infinite`
                                },
                                children: [n.jsx("span", {
                                    style: {
                                        width: 40,
                                        height: 40,
                                        borderRadius: 11,
                                        flexShrink: 0,
                                        background: `${e.color}1A`,
                                        color: e.color,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: e.icon
                                }), n.jsx("span", {
                                    style: {
                                        fontFamily: p,
                                        fontSize: 10.5,
                                        fontWeight: 700,
                                        color: s.text,
                                        lineHeight: 1.2
                                    },
                                    children: e.name
                                })]
                            }, e.name))
                        }), n.jsxs("div", {
                            style: {
                                marginTop: "auto",
                                paddingTop: 16
                            },
                            children: [n.jsx("div", {
                                style: {
                                    marginBottom: 12
                                },
                                children: n.jsx(Rd, {
                                    icon: u0,
                                    children: "Integrações nativas"
                                })
                            }), n.jsx("div", {
                                style: {
                                    borderRadius: 14,
                                    border: `1px solid ${s.border}`,
                                    background: "#FFFFFF",
                                    padding: "14px 0",
                                    overflow: "hidden"
                                },
                                children: n.jsx(ft, {
                                    logos: m0,
                                    mono: !1,
                                    height: 41,
                                    gap: 34
                                })
                            })]
                        })]
                    }), n.jsx(Td, {
                        dir: "in"
                    }), n.jsxs("div", {
                        style: {
                            flex: "1 1 300px",
                            minWidth: 270,
                            borderRadius: 22,
                            padding: 28,
                            background: `linear-gradient(160deg, ${s.primary} 0%, ${s.accent} 100%)`,
                            color: "white",
                            boxShadow: "0 24px 60px rgba(5,96,255,0.34)",
                            display: "flex",
                            flexDirection: "column",
                            position: "relative",
                            overflow: "visible"
                        },
                        children: [n.jsx(v0, {}), n.jsx("div", {
                            style: {
                                position: "absolute",
                                top: -90,
                                left: -90,
                                width: 260,
                                height: 260,
                                borderRadius: "50%",
                                background: "radial-gradient(circle, rgba(255,255,255,0.18), transparent 65%)",
                                animation: "flow-glow 4s ease-in-out infinite",
                                pointerEvents: "none"
                            }
                        }), n.jsxs("div", {
                            style: {
                                position: "relative",
                                zIndex: 1,
                                display: "flex",
                                flexDirection: "column",
                                height: "100%"
                            },
                            children: [n.jsx("img", {
                                src: "/assets/logo.png",
                                alt: "IMOBMEET",
                                style: {
                                    height: 30,
                                    width: "auto",
                                    filter: "brightness(0) invert(1)",
                                    marginBottom: 18,
                                    alignSelf: "flex-start"
                                }
                            }), n.jsx("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 8
                                },
                                children: g0.map((e, t) => n.jsxs("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 10,
                                        fontFamily: p,
                                        fontSize: 13,
                                        fontWeight: 600,
                                        animation: `flow-pop 0.5s ease ${.25+t*.1}s both`
                                    },
                                    children: [n.jsx("span", {
                                        style: {
                                            width: 20,
                                            height: 20,
                                            borderRadius: 6,
                                            flexShrink: 0,
                                            background: "rgba(255,255,255,0.2)",
                                            color: "white",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        },
                                        children: n.jsx("svg", {
                                            width: "12",
                                            height: "12",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "3",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: n.jsx("path", {
                                                d: "M20 6 9 17l-5-5"
                                            })
                                        })
                                    }), e]
                                }, e))
                            }), n.jsxs("div", {
                                style: {
                                    marginTop: "auto",
                                    paddingTop: 18,
                                    fontFamily: p,
                                    fontSize: 12,
                                    color: "rgba(255,255,255,0.85)",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    fontWeight: 600
                                },
                                children: [n.jsx("span", {
                                    className: "pulse-dot",
                                    style: {
                                        width: 8,
                                        height: 8,
                                        borderRadius: "50%",
                                        background: "#34D399",
                                        display: "inline-block"
                                    }
                                }), "Lead qualificado e convertido em venda"]
                            })]
                        })]
                    }), n.jsx(Td, {
                        dir: "out"
                    }), n.jsxs("div", {
                        style: {
                            ...Wd,
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: [n.jsx("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                gap: 10,
                                marginBottom: 20
                            },
                            children: [{
                                t: "Emissão de boletos",
                                d: "Geração e remessa em lote"
                            }, {
                                t: "Régua de cobrança",
                                d: "Automática no WhatsApp"
                            }, {
                                t: "Gestão de recebíveis",
                                d: "Conciliação e fluxo de caixa"
                            }, {
                                t: "Gestão de Contas",
                                d: "A pagar e a receber"
                            }].map((e, t) => n.jsxs("div", {
                                className: "flow-chip",
                                style: {
                                    padding: "13px 14px",
                                    borderRadius: 13,
                                    background: s.surface,
                                    border: `1px solid ${s.border}`,
                                    animation: `flow-pop 0.5s ease ${.4+t*.16}s both`
                                },
                                children: [n.jsx("div", {
                                    style: {
                                        fontFamily: p,
                                        fontSize: 14,
                                        fontWeight: 800,
                                        color: s.text
                                    },
                                    children: e.t
                                }), n.jsx("div", {
                                    style: {
                                        fontFamily: p,
                                        fontSize: 12,
                                        color: s.muted,
                                        marginTop: 2
                                    },
                                    children: e.d
                                })]
                            }, e.t))
                        }), n.jsxs("div", {
                            style: {
                                marginTop: "auto"
                            },
                            children: [n.jsx("div", {
                                style: {
                                    marginBottom: 14
                                },
                                children: n.jsxs(Rd, {
                                    icon: p0,
                                    children: [n.jsx("span", {
                                        style: {
                                            color: s.accent
                                        },
                                        children: "+30"
                                    }), " bancos integrados"]
                                })
                            }), n.jsx("div", {
                                style: {
                                    borderRadius: 14,
                                    border: `1px solid ${s.border}`,
                                    background: "#FFFFFF",
                                    padding: "16px 0",
                                    overflow: "hidden"
                                },
                                children: n.jsx(ft, {
                                    logos: f0,
                                    mono: !1,
                                    height: 26,
                                    gap: 34
                                })
                            })]
                        })]
                    })]
                })
            }), n.jsx(k, {
                delay: 2,
                children: n.jsxs("div", {
                    style: {
                        marginTop: 24,
                        display: "flex",
                        gap: 18,
                        alignItems: "stretch",
                        minHeight: 217
                    },
                    className: "brokers-row",
                    children: [n.jsxs("div", {
                        style: {
                            flexShrink: 0,
                            width: 224,
                            borderRadius: 22,
                            overflow: "hidden",
                            position: "relative",
                            border: `1px solid ${s.border}`,
                            boxShadow: "0 16px 40px rgba(10,15,30,0.08)",
                            background: `linear-gradient(160deg, ${s.accent}, ${s.primary})`
                        },
                        children: [n.jsx("img", {
                            src: "/assets/people/corretora-imobiliaria.jpg",
                            alt: "Corretora conectada ao IMOBMEET",
                            loading: "lazy",
                            onError: e => {
                                e.currentTarget.style.opacity = 0
                            },
                            style: {
                                position: "absolute",
                                inset: 0,
                                width: "100%",
                                height: "100%",
                                objectFit: "cover"
                            }
                        }), n.jsxs("span", {
                            style: {
                                position: "absolute",
                                bottom: 12,
                                left: 12,
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 6,
                                background: "#10B981",
                                color: "white",
                                borderRadius: 999,
                                padding: "4px 10px",
                                fontFamily: p,
                                fontSize: 11.5,
                                fontWeight: 800,
                                border: "2px solid #FFFFFF",
                                boxShadow: "0 3px 8px rgba(10,15,30,0.2)"
                            },
                            children: [n.jsx("span", {
                                className: "pulse-dot",
                                style: {
                                    width: 6,
                                    height: 6,
                                    borderRadius: "50%",
                                    background: "#FFFFFF",
                                    display: "inline-block"
                                }
                            }), "online"]
                        })]
                    }), n.jsxs("div", {
                        style: {
                            flex: 1,
                            minWidth: 0,
                            borderRadius: 22,
                            overflow: "hidden",
                            position: "relative",
                            background: "#FFFFFF",
                            border: `1px solid ${s.border}`,
                            boxShadow: "0 16px 40px rgba(10,15,30,0.08)",
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: [n.jsx("div", {
                            style: {
                                position: "absolute",
                                inset: 0,
                                opacity: .6,
                                pointerEvents: "none",
                                backgroundImage: "radial-gradient(rgba(5,96,255,0.07) 1px, transparent 1px)",
                                backgroundSize: "26px 26px"
                            }
                        }), n.jsx("div", {
                            style: {
                                position: "absolute",
                                top: -80,
                                right: 120,
                                width: 360,
                                height: 360,
                                borderRadius: "50%",
                                background: "radial-gradient(circle, rgba(5,96,255,0.10), transparent 65%)",
                                pointerEvents: "none"
                            }
                        }), n.jsxs("div", {
                            style: {
                                position: "relative",
                                flex: 1,
                                padding: "18px 28px",
                                display: "flex",
                                alignItems: "center",
                                gap: 28,
                                flexWrap: "wrap",
                                justifyContent: "space-between"
                            },
                            children: [n.jsxs("div", {
                                style: {
                                    minWidth: 250
                                },
                                children: [n.jsxs("div", {
                                    style: {
                                        fontFamily: p,
                                        fontSize: 11,
                                        fontWeight: 800,
                                        letterSpacing: 1,
                                        textTransform: "uppercase",
                                        color: "#10B981",
                                        marginBottom: 6,
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 7
                                    },
                                    children: [n.jsx("span", {
                                        className: "pulse-dot",
                                        style: {
                                            width: 7,
                                            height: 7,
                                            borderRadius: "50%",
                                            background: "#10B981",
                                            display: "inline-block"
                                        }
                                    }), "Rede IMOBMEET em tempo real"]
                                }), n.jsx("div", {
                                    style: {
                                        fontFamily: p,
                                        fontSize: 24,
                                        fontWeight: 800,
                                        color: s.text,
                                        letterSpacing: -.5,
                                        lineHeight: 1.15,
                                        whiteSpace: "nowrap"
                                    },
                                    children: "Corretores conectados em todo o Brasil"
                                }), n.jsx("div", {
                                    style: {
                                        display: "flex",
                                        gap: 28,
                                        marginTop: 12
                                    },
                                    children: [
                                        ["+10.000", "corretores ativos"],
                                        ["+300", "cidades"],
                                        ["24/7", "online"]
                                    ].map(([e, t]) => n.jsxs("div", {
                                        children: [n.jsx("div", {
                                            style: {
                                                fontFamily: p,
                                                fontSize: 22,
                                                fontWeight: 800,
                                                color: s.text,
                                                letterSpacing: -.5
                                            },
                                            children: e
                                        }), n.jsx("div", {
                                            style: {
                                                fontFamily: p,
                                                fontSize: 11.5,
                                                color: s.muted,
                                                fontWeight: 600
                                            },
                                            children: t
                                        })]
                                    }, t))
                                })]
                            }), n.jsxs("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-end",
                                    gap: 14
                                },
                                children: [n.jsxs("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: [x0.map((e, t) => n.jsxs("div", {
                                        style: {
                                            position: "relative",
                                            width: 44,
                                            height: 44,
                                            borderRadius: "50%",
                                            background: e.bg,
                                            color: "white",
                                            fontFamily: p,
                                            fontSize: 14,
                                            fontWeight: 800,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            border: "2px solid #FFFFFF",
                                            marginLeft: t === 0 ? 0 : -12,
                                            boxShadow: "0 3px 8px rgba(10,15,30,0.12)",
                                            animation: `float-y ${4+t%3*.4}s ease-in-out ${t*.18}s infinite`
                                        },
                                        children: [n.jsx("span", {
                                            style: {
                                                position: "relative",
                                                zIndex: 0
                                            },
                                            children: e.i
                                        }), n.jsx("img", {
                                            src: e.photo,
                                            alt: e.name,
                                            loading: "lazy",
                                            onError: r => {
                                                r.currentTarget.style.display = "none"
                                            },
                                            style: {
                                                position: "absolute",
                                                inset: 0,
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                                borderRadius: "50%",
                                                zIndex: 1
                                            }
                                        }), n.jsx("span", {
                                            style: {
                                                position: "absolute",
                                                bottom: 0,
                                                right: 0,
                                                width: 10,
                                                height: 10,
                                                borderRadius: "50%",
                                                background: "#10B981",
                                                border: "2px solid #FFFFFF",
                                                zIndex: 2
                                            }
                                        })]
                                    }, t)), n.jsx("div", {
                                        style: {
                                            position: "relative",
                                            zIndex: 5,
                                            width: 44,
                                            height: 44,
                                            borderRadius: "50%",
                                            marginLeft: -12,
                                            background: s.bgAlt,
                                            border: "2px solid #FFFFFF",
                                            color: s.text,
                                            fontFamily: p,
                                            fontSize: 12.5,
                                            fontWeight: 800,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            boxShadow: "0 3px 8px rgba(10,15,30,0.12)"
                                        },
                                        children: "+10k"
                                    })]
                                }), n.jsxs("div", {
                                    style: {
                                        display: "flex",
                                        gap: 10
                                    },
                                    children: [n.jsx("a", {
                                        href: "https://apps.apple.com/us/app/imobmeet/id6759934477",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        "aria-label": "Baixar na App Store",
                                        children: n.jsx("img", {
                                            src: "/assets/app-store.svg",
                                            alt: "Disponível na App Store",
                                            style: {
                                                height: 36,
                                                display: "block"
                                            }
                                        })
                                    }), n.jsx("a", {
                                        href: "https://play.google.com/store/apps/details?id=com.imobmeet.imobmeetapp&hl=pt_BR",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        "aria-label": "Baixar no Google Play",
                                        children: n.jsx("img", {
                                            src: "/assets/google-play.svg",
                                            alt: "Disponível no Google Play",
                                            style: {
                                                height: 36,
                                                display: "block"
                                            }
                                        })
                                    })]
                                })]
                            })]
                        }), n.jsx("div", {
                            style: {
                                position: "relative",
                                borderTop: `1px solid ${s.border}`,
                                padding: "10px 0"
                            },
                            children: n.jsx("div", {
                                className: "logo-marquee",
                                children: n.jsx("div", {
                                    className: "logo-track",
                                    style: {
                                        gap: 12
                                    },
                                    children: [...Id, ...Id].map((e, t) => n.jsxs("span", {
                                        style: {
                                            flexShrink: 0,
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 6,
                                            padding: "6px 13px",
                                            borderRadius: 999,
                                            background: s.bgAlt,
                                            border: `1px solid ${s.border}`,
                                            color: s.text,
                                            fontFamily: p,
                                            fontSize: 13,
                                            fontWeight: 600,
                                            whiteSpace: "nowrap"
                                        },
                                        children: [n.jsx("span", {
                                            style: {
                                                color: s.accent,
                                                display: "inline-flex"
                                            },
                                            children: y0
                                        }), e]
                                    }, t))
                                })
                            })
                        })]
                    })]
                })
            })]
        })]
    })
}
const Be = (e = {}) => ({
        background: s.surface,
        border: `1.5px solid ${s.border}`,
        borderRadius: 20,
        padding: 28,
        height: "100%",
        position: "relative",
        overflow: "hidden",
        fontFamily: p,
        color: s.text,
        boxShadow: "0 10px 30px rgba(10,15,30,0.05)",
        transition: "transform 0.4s cubic-bezier(.16,1,.3,1), border-color 0.3s, box-shadow 0.4s",
        ...e
    }),
    Ne = {
        fontFamily: p,
        fontSize: 24,
        fontWeight: 800,
        color: s.text,
        margin: 0,
        letterSpacing: -.6,
        lineHeight: 1.15
    },
    $e = {
        fontFamily: p,
        fontSize: 13.5,
        color: s.muted,
        fontWeight: 500,
        marginTop: 8,
        marginBottom: 0,
        lineHeight: 1.5
    };

function Vn() {
    return null
}

function b0() {
    const e = [{
        name: "Leads",
        pct: 100,
        color: "#5C97FF"
    }, {
        name: "Atendendo",
        pct: 64,
        color: "#3A7DFF"
    }, {
        name: "Proposta",
        pct: 28,
        color: "#94A3B8"
    }, {
        name: "Contrato",
        pct: 14,
        color: "#34D399"
    }];
    return n.jsxs("div", {
        className: "bento-card",
        style: Be({
            minHeight: 280,
            display: "flex",
            flexDirection: "column"
        }),
        children: [n.jsx(Vn, {
            color: "#0560FF",
            x: "92%",
            y: "14%",
            size: 300,
            opacity: .3
        }), n.jsxs("div", {
            children: [n.jsx("h3", {
                style: Ne,
                children: "Gestão de Leads"
            }), n.jsx("p", {
                style: $e,
                children: "Do primeiro lead à assinatura do contrato."
            })]
        }), n.jsxs("div", {
            style: {
                marginTop: 26
            },
            children: [n.jsx("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 14
                },
                children: n.jsx("span", {
                    style: {
                        fontFamily: p,
                        fontSize: 11,
                        fontWeight: 800,
                        letterSpacing: .5,
                        textTransform: "uppercase",
                        color: s.muted
                    },
                    children: "Leads no funil agora"
                })
            }), n.jsxs("div", {
                style: {
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    ["https://randomuser.me/api/portraits/women/21.jpg", "https://randomuser.me/api/portraits/men/41.jpg", "https://randomuser.me/api/portraits/women/63.jpg", "https://randomuser.me/api/portraits/men/15.jpg", "https://randomuser.me/api/portraits/women/8.jpg", "https://randomuser.me/api/portraits/men/29.jpg"].map((t, r) => n.jsx("div", {
                        style: {
                            width: 42,
                            height: 42,
                            borderRadius: "50%",
                            marginLeft: r ? -12 : 0,
                            border: `2px solid ${s.surface}`,
                            background: "linear-gradient(135deg,#0560FF,#0560FF)",
                            overflow: "hidden",
                            boxShadow: "0 4px 10px rgba(10,15,30,0.12)",
                            flexShrink: 0,
                            animation: `float-y ${4+r%3*.4}s ease-in-out ${r*.15}s infinite`
                        },
                        children: n.jsx("img", {
                            src: t,
                            alt: "Cliente do IMOBMEET",
                            loading: "lazy",
                            onError: o => {
                                o.currentTarget.style.display = "none"
                            },
                            style: {
                                width: "100%",
                                height: "100%",
                                objectFit: "cover"
                            }
                        })
                    }, r)), n.jsxs("div", {
                        style: {
                            marginLeft: 14,
                            fontFamily: p
                        },
                        children: [n.jsx("div", {
                            style: {
                                fontSize: 18,
                                fontWeight: 800,
                                color: s.text,
                                letterSpacing: -.3
                            },
                            children: "+1.248"
                        }), n.jsx("div", {
                            style: {
                                fontSize: 11,
                                color: s.muted,
                                fontWeight: 600
                            },
                            children: "leads ativos"
                        })]
                    })
                ]
            })]
        }), n.jsx("div", {
            style: {
                marginTop: "auto",
                paddingTop: 22,
                display: "flex",
                flexDirection: "column",
                gap: 9
            },
            children: e.map((t, r) => n.jsxs("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    animation: `count-up 0.5s cubic-bezier(.16,1,.3,1) ${.1+r*.06}s both`
                },
                children: [n.jsx("span", {
                    style: {
                        fontFamily: Pt,
                        fontSize: 10,
                        fontWeight: 700,
                        color: s.muted,
                        width: 18
                    },
                    children: String(r + 1).padStart(2, "0")
                }), n.jsx("span", {
                    style: {
                        fontSize: 12.5,
                        fontWeight: 600,
                        color: s.text,
                        width: 88
                    },
                    children: t.name
                }), n.jsx("div", {
                    style: {
                        flex: 1,
                        height: 6,
                        borderRadius: 4,
                        background: s.bgAlt,
                        overflow: "hidden"
                    },
                    children: n.jsx("div", {
                        className: "bar-grow bento-bar",
                        style: {
                            width: `${t.pct}%`,
                            height: 6,
                            background: t.color,
                            borderRadius: 4,
                            animationDelay: `${.4+r*.08}s`,
                            boxShadow: `0 0 8px ${t.color}66`
                        }
                    })
                }), n.jsxs("span", {
                    style: {
                        fontSize: 11.5,
                        fontWeight: 800,
                        color: t.color,
                        width: 38,
                        textAlign: "right",
                        fontFamily: Pt
                    },
                    children: [t.pct, "%"]
                })]
            }, t.name))
        })]
    })
}

function k0() {
    const e = {
            v: {
                label: "Vendido",
                color: "#EF4444",
                pct: "11%",
                count: 50
            },
            d: {
                label: "Disponível",
                color: "#10B981",
                pct: "80%",
                count: 372
            },
            p: {
                label: "Pré-Reserva",
                color: "#3B82F6",
                pct: "4%",
                count: 18
            },
            r: {
                label: "Reservado",
                color: "#F59E0B",
                pct: "3%",
                count: 14
            },
            b: {
                label: "Bloqueado",
                color: "#1F2937",
                pct: "2%",
                count: 8
            }
        },
        t = [
            ["p", "p", "d", "d", "p", "d", "d", "p"],
            ["d", "d", "d", "r", "d", "d", "d", "d"],
            ["d", "v", "d", "d", "v", "d", "r", "d"],
            ["d", "r", "v", "b", "v", "d", "d", "d"],
            ["v", "d", "d", "d", "d", "b", "d", "v"],
            ["d", "d", "r", "v", "d", "d", "d", "d"],
            ["d", "v", "d", "d", "v", "d", "p", "d"]
        ],
        r = ["29°", "28°", "27°", "26°", "25°", "24°", "23°"],
        o = ["v", "d", "p", "r", "b"];
    return n.jsxs("div", {
        className: "bento-card",
        style: Be({
            minHeight: 280,
            display: "flex",
            flexDirection: "column"
        }),
        children: [n.jsx(Vn, {
            color: "#10B981",
            x: "92%",
            y: "14%",
            size: 260,
            opacity: .18
        }), n.jsx("div", {
            style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                marginBottom: 18,
                gap: 14
            },
            children: n.jsxs("div", {
                children: [n.jsx("h3", {
                    style: Ne,
                    children: "Gestão de unidades"
                }), n.jsx("p", {
                    style: $e,
                    children: "Disponibilidade vertical e horizontal."
                })]
            })
        }), n.jsx("div", {
            style: {
                display: "grid",
                gridTemplateColumns: `repeat(${o.length}, 1fr)`,
                gap: 4,
                marginBottom: 12
            },
            children: o.map(i => {
                const a = e[i];
                return n.jsxs("div", {
                    className: "bento-pill",
                    style: {
                        background: a.color,
                        borderRadius: 6,
                        padding: "5px 7px 6px",
                        display: "flex",
                        flexDirection: "column",
                        boxShadow: `0 4px 10px ${a.color}33`
                    },
                    children: [n.jsxs("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 2
                        },
                        children: [n.jsx("span", {
                            style: {
                                fontSize: 8,
                                fontWeight: 800,
                                color: "white",
                                letterSpacing: .2,
                                textTransform: "uppercase",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            },
                            children: a.label
                        }), n.jsx("span", {
                            style: {
                                fontSize: 8,
                                fontWeight: 800,
                                color: "white",
                                opacity: .85
                            },
                            children: a.pct
                        })]
                    }), n.jsx("div", {
                        style: {
                            fontFamily: p,
                            fontSize: 14,
                            fontWeight: 800,
                            color: "white",
                            lineHeight: 1,
                            letterSpacing: -.3
                        },
                        children: a.count
                    })]
                }, i)
            })
        }), n.jsxs("div", {
            style: {
                background: s.primary,
                borderRadius: "6px 6px 0 0",
                padding: "6px 10px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontFamily: p,
                color: "white"
            },
            children: [n.jsxs("div", {
                style: {
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6
                },
                children: [n.jsx("svg", {
                    width: "9",
                    height: "9",
                    viewBox: "0 0 24 24",
                    fill: "white",
                    children: n.jsx("path", {
                        d: "M7 10l5-5 5 5z"
                    })
                }), n.jsx("span", {
                    style: {
                        fontSize: 10,
                        fontWeight: 800
                    },
                    children: "Torre 1"
                })]
            }), n.jsx("span", {
                style: {
                    fontSize: 9,
                    color: "rgba(255,255,255,0.75)",
                    fontFamily: p,
                    fontWeight: 600
                },
                children: "Total 462 · Disp 372"
            })]
        }), n.jsx("div", {
            style: {
                background: s.bgAlt,
                border: `1px solid ${s.border}`,
                borderTop: "none",
                borderRadius: "0 0 8px 8px",
                padding: 6,
                display: "flex",
                flexDirection: "column",
                gap: 3
            },
            children: t.map((i, a) => n.jsxs("div", {
                style: {
                    display: "flex",
                    gap: 3,
                    alignItems: "stretch"
                },
                children: [n.jsxs("div", {
                    style: {
                        width: 32,
                        flexShrink: 0,
                        background: s.bgAlt,
                        borderRadius: 3,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        fontFamily: p
                    },
                    children: [n.jsx("span", {
                        style: {
                            fontSize: 8.5,
                            fontWeight: 800,
                            color: s.text
                        },
                        children: r[a]
                    }), n.jsx("span", {
                        style: {
                            fontSize: 6.5,
                            color: s.muted,
                            letterSpacing: .6
                        },
                        children: "ANDAR"
                    })]
                }), n.jsx("div", {
                    style: {
                        flex: 1,
                        display: "grid",
                        gridTemplateColumns: `repeat(${i.length}, 1fr)`,
                        gap: 3
                    },
                    children: i.map((l, d) => {
                        const c = e[l],
                            u = `${r[a].replace("°","")}${String(d+1).padStart(2,"0")}`;
                        return n.jsx("div", {
                            className: "bento-unit",
                            style: {
                                background: c.color,
                                borderRadius: 3,
                                padding: "2px 3px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                color: (l === "b" || ["d", "rp", "p"].includes(l), "white"),
                                fontFamily: p,
                                minHeight: 18,
                                animation: `count-up 0.3s ease-out ${(a*8+d)*.008}s both`
                            },
                            children: n.jsx("span", {
                                style: {
                                    fontSize: 8,
                                    fontWeight: 800,
                                    lineHeight: 1
                                },
                                children: u
                            })
                        }, d)
                    })
                })]
            }, a))
        })]
    })
}
const w0 = {
    pix: e => n.jsxs("svg", {
        width: "15",
        height: "15",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: e,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [n.jsx("path", {
            d: "M12 3.2 8.4 6.8a2.4 2.4 0 0 0 0 3.4L12 13.8l3.6-3.6a2.4 2.4 0 0 0 0-3.4z"
        }), n.jsx("path", {
            d: "M12 10.2 8.4 13.8a2.4 2.4 0 0 0 0 3.4L12 20.8l3.6-3.6a2.4 2.4 0 0 0 0-3.4z"
        })]
    }),
    boleto: e => n.jsx("svg", {
        width: "15",
        height: "15",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: e,
        strokeWidth: "1.7",
        strokeLinecap: "round",
        children: n.jsx("path", {
            d: "M4 6v12M7 6v12M10 6v12M12.5 6v12M15 6v12M18 6v12M20 6v12"
        })
    }),
    cartao: e => n.jsxs("svg", {
        width: "15",
        height: "15",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: e,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [n.jsx("rect", {
            x: "3",
            y: "6",
            width: "18",
            height: "13",
            rx: "2"
        }), n.jsx("line", {
            x1: "3",
            y1: "10",
            x2: "21",
            y2: "10"
        }), n.jsx("line", {
            x1: "6.5",
            y1: "15",
            x2: "11",
            y2: "15"
        })]
    })
};

function S0() {
    const e = [{
        client: "João Carlos · #2847",
        value: "R$ 8.793,00",
        due: "05/06",
        method: "pix",
        label: "PIX",
        status: "Em dia",
        color: "#34D399"
    }, {
        client: "Ana Paula · #2846",
        value: "R$ 12.450,00",
        due: "12/06",
        method: "boleto",
        label: "Boleto",
        status: "A vencer",
        color: "#5C97FF"
    }, {
        client: "Pedro Lima · #2845",
        value: "R$ 6.220,00",
        due: "Hoje",
        method: "cartao",
        label: "Cartão",
        status: "Atrasado",
        color: "#94A3B8"
    }];
    return n.jsxs("div", {
        className: "bento-card",
        style: Be({
            minHeight: 280
        }),
        children: [n.jsx("h3", {
            style: Ne,
            children: "Contas a Receber"
        }), n.jsx("p", {
            style: $e,
            children: "Boleto, PIX, Cartão e Régua de Cobrança."
        }), n.jsx("div", {
            style: {
                marginTop: 20,
                display: "flex",
                flexDirection: "column",
                gap: 8
            },
            children: e.map((t, r) => n.jsxs("div", {
                className: "bento-row",
                style: {
                    background: s.surface,
                    border: "1px solid #CBD5E1",
                    borderRadius: 11,
                    padding: "10px 12px",
                    display: "flex",
                    alignItems: "center",
                    gap: 11,
                    animation: `count-up 0.4s ease-out ${.1+r*.08}s both`
                },
                children: [n.jsx("div", {
                    style: {
                        width: 32,
                        height: 32,
                        borderRadius: 8,
                        background: `${t.color}1F`,
                        border: `1px solid ${t.color}55`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0
                    },
                    children: w0[t.method](t.color)
                }), n.jsxs("div", {
                    style: {
                        flex: 1,
                        minWidth: 0
                    },
                    children: [n.jsx("div", {
                        style: {
                            fontSize: 11.5,
                            fontWeight: 700,
                            color: s.text,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        },
                        children: t.client
                    }), n.jsxs("div", {
                        style: {
                            fontSize: 10,
                            color: s.muted,
                            marginTop: 1
                        },
                        children: [t.label, " · ", t.value, " · venc. ", t.due]
                    })]
                }), n.jsx("span", {
                    style: {
                        fontSize: 9.5,
                        fontWeight: 800,
                        color: t.color,
                        padding: "2px 7px",
                        borderRadius: 5,
                        background: `${t.color}14`,
                        border: `1px solid ${t.color}44`,
                        whiteSpace: "nowrap",
                        fontFamily: p
                    },
                    children: t.status
                })]
            }, r))
        }), n.jsxs("div", {
            style: {
                marginTop: 12,
                background: s.bgAlt,
                border: `1px solid ${s.border}`,
                borderRadius: 12,
                padding: "11px 12px"
            },
            children: [n.jsxs("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    marginBottom: 9
                },
                children: [n.jsx("span", {
                    style: {
                        fontSize: 9.5,
                        fontWeight: 800,
                        letterSpacing: .5,
                        textTransform: "uppercase",
                        color: s.muted
                    },
                    children: "Régua de cobrança"
                }), n.jsx("span", {
                    style: {
                        fontSize: 8.5,
                        fontWeight: 800,
                        color: s.success,
                        background: "#ECFDF5",
                        border: "1px solid #A7F3D0",
                        padding: "1px 6px",
                        borderRadius: 5
                    },
                    children: "automática"
                })]
            }), n.jsxs("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    marginBottom: 7
                },
                children: [n.jsx("span", {
                    style: {
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        flexShrink: 0,
                        background: "#25D366",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    },
                    children: n.jsx("svg", {
                        width: "13",
                        height: "13",
                        viewBox: "0 0 24 24",
                        fill: "white",
                        "aria-hidden": "true",
                        children: n.jsx("path", {
                            d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347M12.05 21.785a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884"
                        })
                    })
                }), n.jsx("div", {
                    style: {
                        flex: 1,
                        minWidth: 0,
                        background: "#ECFDF5",
                        border: "1px solid #C7F0DC",
                        borderRadius: "3px 11px 11px 11px",
                        padding: "6px 9px"
                    },
                    children: n.jsxs("div", {
                        style: {
                            fontSize: 10,
                            color: s.text,
                            lineHeight: 1.35
                        },
                        children: ["Olá João! Seu boleto ", n.jsx("b", {
                            children: "#2847"
                        }), " vence hoje. Pague pelo link 🔗"]
                    })
                }), n.jsx("span", {
                    style: {
                        fontSize: 9,
                        color: "#34B7F1",
                        fontWeight: 800,
                        flexShrink: 0,
                        alignSelf: "flex-end"
                    },
                    children: "✓✓"
                })]
            }), n.jsxs("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: 8
                },
                children: [n.jsx("span", {
                    style: {
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        flexShrink: 0,
                        background: s.accentLight,
                        border: `1px solid ${s.accentBorder}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    },
                    children: n.jsxs("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: s.accent,
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: [n.jsx("rect", {
                            x: "3",
                            y: "5",
                            width: "18",
                            height: "14",
                            rx: "2"
                        }), n.jsx("path", {
                            d: "m3 7 9 6 9-6"
                        })]
                    })
                }), n.jsx("div", {
                    style: {
                        flex: 1,
                        minWidth: 0
                    },
                    children: n.jsx("div", {
                        style: {
                            fontSize: 10,
                            color: s.text,
                            fontWeight: 600
                        },
                        children: "Lembrete enviado por e-mail"
                    })
                }), n.jsxs("span", {
                    style: {
                        fontSize: 8.5,
                        fontWeight: 800,
                        color: s.success,
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 3,
                        flexShrink: 0
                    },
                    children: [n.jsx("svg", {
                        width: "10",
                        height: "10",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "3.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: n.jsx("path", {
                            d: "M20 6 9 17l-5-5"
                        })
                    }), "Entregue"]
                })]
            })]
        })]
    })
}

function C0() {
    const e = [{
            name: "Comissões · jun",
            value: "R$ 42.300,00",
            due: "15/06"
        }, {
            name: "Mídia & Anúncios",
            value: "R$ 12.860,00",
            due: "12/06"
        }, {
            name: "Contabilidade",
            value: "R$ 15.900,00",
            due: "25/06"
        }, {
            name: "Aluguel · escritório",
            value: "R$ 23.100,00",
            due: "20/06"
        }, {
            name: "Fornecedor Cloud · TI",
            value: "R$ 8.420,00",
            due: "10/06"
        }, {
            name: "Impostos · DAS",
            value: "R$ 11.750,00",
            due: "22/06"
        }, {
            name: "Telefonia & Internet",
            value: "R$ 3.540,00",
            due: "18/06"
        }, {
            name: "Marketing & Vendas",
            value: "R$ 6.480,00",
            due: "28/06"
        }],
        t = "#F4776B",
        r = [...e, ...e];
    return n.jsxs("div", {
        className: "bento-card",
        style: Be({
            minHeight: 280,
            display: "flex",
            flexDirection: "column"
        }),
        children: [n.jsx("h3", {
            style: Ne,
            children: "Contas a Pagar"
        }), n.jsx("p", {
            style: $e,
            children: "Fornecedores, folha e despesas integrados."
        }), n.jsx("div", {
            className: "pay-marquee",
            style: {
                marginTop: 18,
                height: 210,
                overflow: "hidden",
                position: "relative",
                WebkitMaskImage: "linear-gradient(180deg, transparent 0, #000 14%, #000 86%, transparent 100%)",
                maskImage: "linear-gradient(180deg, transparent 0, #000 14%, #000 86%, transparent 100%)"
            },
            children: n.jsx("div", {
                className: "pay-track",
                children: r.map((o, i) => n.jsxs("div", {
                    style: {
                        background: s.surface,
                        border: `1px solid ${s.border}`,
                        borderRadius: 11,
                        padding: "12px 14px",
                        marginBottom: 8,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        boxShadow: "0 6px 16px rgba(10,15,30,0.05)"
                    },
                    children: [n.jsxs("div", {
                        style: {
                            minWidth: 0
                        },
                        children: [n.jsx("div", {
                            style: {
                                fontSize: 11.5,
                                fontWeight: 700,
                                color: s.text,
                                whiteSpace: "nowrap"
                            },
                            children: o.name
                        }), n.jsxs("div", {
                            style: {
                                fontSize: 10,
                                color: s.muted,
                                marginTop: 2
                            },
                            children: ["vence em ", o.due]
                        })]
                    }), n.jsx("div", {
                        style: {
                            fontSize: 13,
                            fontWeight: 800,
                            color: t,
                            fontFamily: Pt,
                            letterSpacing: -.3,
                            whiteSpace: "nowrap"
                        },
                        children: o.value
                    })]
                }, i))
            })
        }), n.jsxs("div", {
            style: {
                marginTop: 18
            },
            children: [n.jsx("div", {
                style: {
                    fontSize: 9.5,
                    fontWeight: 800,
                    letterSpacing: .5,
                    textTransform: "uppercase",
                    color: s.muted,
                    marginBottom: 11
                },
                children: "Por categoria"
            }), [{
                l: "Comissões",
                pct: 92,
                v: "R$ 118.700"
            }, {
                l: "Despesas",
                pct: 46,
                v: "R$ 59.400"
            }, {
                l: "Marketing",
                pct: 29,
                v: "R$ 37.680"
            }].map((o, i, a) => n.jsxs("div", {
                style: {
                    marginBottom: i === a.length - 1 ? 0 : 10
                },
                children: [n.jsxs("div", {
                    style: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "baseline",
                        marginBottom: 5
                    },
                    children: [n.jsx("span", {
                        style: {
                            fontSize: 11.5,
                            color: s.text,
                            fontWeight: 600,
                            fontFamily: p
                        },
                        children: o.l
                    }), n.jsx("span", {
                        style: {
                            fontSize: 11.5,
                            color: s.muted,
                            fontWeight: 700,
                            fontFamily: p
                        },
                        children: o.v
                    })]
                }), n.jsx("div", {
                    style: {
                        height: 6,
                        background: s.bgAlt,
                        borderRadius: 4,
                        overflow: "hidden"
                    },
                    children: n.jsx("div", {
                        className: "bar-grow bento-bar",
                        style: {
                            width: `${o.pct}%`,
                            height: 6,
                            borderRadius: 4,
                            background: `linear-gradient(90deg, ${t}, #F6A398)`,
                            animationDelay: `${.1+i*.08}s`
                        }
                    })
                })]
            }, o.l))]
        })]
    })
}

function E0() {
    const e = [{
        name: "Corretor",
        pct: 60,
        color: "#5C97FF",
        amount: "R$ 17.640"
    }, {
        name: "Gerente",
        pct: 25,
        color: "#34D399",
        amount: "R$ 7.350"
    }, {
        name: "Imobiliária",
        pct: 15,
        color: "#94A3B8",
        amount: "R$ 4.410"
    }];
    return n.jsxs("div", {
        className: "bento-card",
        style: Be({
            minHeight: 280
        }),
        children: [n.jsx(Vn, {
            color: "#5C97FF",
            x: "50%",
            y: "100%",
            size: 340,
            opacity: .2
        }), n.jsx("div", {
            style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: 18
            },
            children: n.jsxs("div", {
                children: [n.jsx("h3", {
                    style: Ne,
                    children: "Split de Comissões"
                }), n.jsx("p", {
                    style: $e,
                    children: "Pagadoria integrada — divisão automática por venda."
                })]
            })
        }), n.jsxs("div", {
            style: {
                marginTop: 28
            },
            children: [n.jsx("div", {
                style: {
                    height: 14,
                    borderRadius: 7,
                    overflow: "hidden",
                    display: "flex",
                    marginBottom: 18,
                    border: `1px solid ${s.border}`
                },
                children: e.map((t, r) => n.jsx("div", {
                    className: "bar-grow",
                    style: {
                        width: `${t.pct}%`,
                        height: "100%",
                        background: t.color,
                        boxShadow: `inset 0 0 12px ${t.color}66`,
                        animationDelay: `${.2+r*.1}s`,
                        transformOrigin: "left center"
                    }
                }, t.name))
            }), n.jsx("div", {
                style: {
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gap: 12
                },
                children: e.map((t, r) => n.jsxs("div", {
                    className: "bento-row",
                    style: {
                        background: s.surface,
                        border: "1px solid #CBD5E1",
                        borderRadius: 11,
                        padding: "11px 13px",
                        animation: `count-up 0.4s ease-out ${.5+r*.08}s both`
                    },
                    children: [n.jsx("div", {
                        style: {
                            marginBottom: 6
                        },
                        children: n.jsx("span", {
                            style: {
                                fontSize: 11,
                                color: s.muted,
                                fontWeight: 600
                            },
                            children: t.name
                        })
                    }), n.jsxs("div", {
                        style: {
                            fontSize: 18,
                            fontWeight: 800,
                            color: t.color,
                            letterSpacing: -.4,
                            lineHeight: 1,
                            fontFamily: p
                        },
                        children: [t.pct, "%"]
                    }), n.jsx("div", {
                        style: {
                            fontSize: 12,
                            color: s.text,
                            marginTop: 6,
                            fontWeight: 700,
                            fontFamily: p,
                            letterSpacing: -.2
                        },
                        children: t.amount
                    })]
                }, t.name))
            }), n.jsx("div", {
                style: {
                    marginTop: 12,
                    display: "flex",
                    flexDirection: "column",
                    gap: 8
                },
                children: [{
                    name: "Gabriel França",
                    role: "Corretor",
                    photo: "https://randomuser.me/api/portraits/men/45.jpg"
                }, {
                    name: "Marina Lopes",
                    role: "Gerente",
                    photo: "https://randomuser.me/api/portraits/women/68.jpg"
                }, {
                    name: "Vertical Inc.",
                    role: "Imobiliária",
                    logo: !0
                }].map((t, r) => n.jsxs("div", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        background: "#ECFDF5",
                        border: "1px solid #A7F3D0",
                        borderRadius: 12,
                        padding: "10px 12px",
                        animation: `count-up 0.4s ease-out ${.8+r*.08}s both`
                    },
                    children: [t.logo ? n.jsx("span", {
                        style: {
                            width: 38,
                            height: 38,
                            borderRadius: 9,
                            flexShrink: 0,
                            background: "linear-gradient(135deg, #0560FF 0%, #204493 100%)",
                            color: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 2px 8px rgba(5,96,255,0.3)"
                        },
                        children: n.jsxs("svg", {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "1.8",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: [n.jsx("rect", {
                                x: "5",
                                y: "3",
                                width: "14",
                                height: "18",
                                rx: "1.5"
                            }), n.jsx("path", {
                                d: "M9 7h.01M12 7h.01M15 7h.01M9 11h.01M12 11h.01M15 11h.01M9 15h.01M12 15h.01M15 15h.01"
                            }), n.jsx("path", {
                                d: "M10 21v-3h4v3"
                            })]
                        })
                    }) : n.jsx("img", {
                        src: t.photo,
                        alt: t.name,
                        loading: "lazy",
                        style: {
                            width: 38,
                            height: 38,
                            borderRadius: "50%",
                            objectFit: "cover",
                            flexShrink: 0,
                            border: `2px solid ${s.surface}`,
                            boxShadow: "0 2px 8px rgba(10,15,30,0.15)"
                        }
                    }), n.jsxs("div", {
                        style: {
                            minWidth: 0,
                            flex: 1
                        },
                        children: [n.jsxs("div", {
                            style: {
                                fontSize: 12,
                                fontWeight: 800,
                                color: s.text,
                                whiteSpace: "nowrap"
                            },
                            children: [t.name, " ", n.jsxs("span", {
                                style: {
                                    color: s.muted,
                                    fontWeight: 600
                                },
                                children: ["· ", t.role]
                            })]
                        }), n.jsxs("div", {
                            style: {
                                fontSize: 10.5,
                                color: s.success,
                                fontWeight: 700,
                                display: "flex",
                                alignItems: "center",
                                gap: 4,
                                marginTop: 2
                            },
                            children: [n.jsx("svg", {
                                width: "12",
                                height: "12",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "3",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: n.jsx("path", {
                                    d: "M20 6 9 17l-5-5"
                                })
                            }), "Pagamento realizado"]
                        })]
                    }), n.jsx("span", {
                        className: "coin-spin",
                        style: {
                            width: 30,
                            height: 30,
                            borderRadius: "50%",
                            flexShrink: 0,
                            background: "radial-gradient(circle at 35% 30%, #FCE08A 0%, #F5C24B 45%, #E0A92E 100%)",
                            border: "2px solid #F0B73A",
                            boxShadow: "0 3px 8px rgba(224,169,46,0.45), inset 0 1px 2px rgba(255,255,255,0.6)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontFamily: Pt,
                            fontSize: 11,
                            fontWeight: 800,
                            color: "#8A6516"
                        },
                        children: "R$"
                    })]
                }, t.name))
            })]
        })]
    })
}

function F0() {
    const e = [{
        from: "client",
        text: "Olá! Vi o Vertical Park, ainda tem unidade?"
    }, {
        from: "agent",
        text: "Olá Joana! Sim, temos 3 opções de 2 dorm. Posso enviar planta?"
    }, {
        from: "client",
        text: "Pode sim. Aceita visita amanhã?"
    }];
    return n.jsxs("div", {
        className: "bento-card",
        style: Be({
            minHeight: 280
        }),
        children: [n.jsx(Vn, {
            color: "#25D366",
            x: "92%",
            y: "14%",
            size: 260,
            opacity: .2
        }), n.jsxs("div", {
            style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: 14
            },
            children: [n.jsxs("div", {
                children: [n.jsx("h3", {
                    style: Ne,
                    children: "Atendimento WhatsApp"
                }), n.jsx("p", {
                    style: $e,
                    children: "Funil conectado ao seu number business."
                })]
            }), n.jsx("div", {
                style: {
                    width: 38,
                    height: 38,
                    borderRadius: 11,
                    background: "rgba(37,211,102,0.15)",
                    border: "1px solid rgba(37,211,102,0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0
                },
                children: n.jsx("svg", {
                    width: "22",
                    height: "22",
                    viewBox: "0 0 24 24",
                    fill: "#25D366",
                    "aria-hidden": "true",
                    children: n.jsx("path", {
                        d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"
                    })
                })
            })]
        }), n.jsxs("div", {
            style: {
                marginTop: 14,
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                alignSelf: "flex-start",
                padding: "6px 12px",
                borderRadius: 999,
                background: s.bgAlt,
                border: `1px solid ${s.border}`
            },
            children: [n.jsx("img", {
                src: "/assets/meta.png",
                alt: "Meta",
                style: {
                    height: 14,
                    width: "auto",
                    display: "block"
                }
            }), n.jsx("span", {
                style: {
                    width: 1,
                    height: 12,
                    background: s.border,
                    display: "inline-block"
                }
            }), n.jsx("span", {
                style: {
                    fontFamily: p,
                    fontSize: 11.5,
                    fontWeight: 800,
                    color: s.text
                },
                children: "API Oficial"
            })]
        }), n.jsxs("div", {
            style: {
                marginTop: 16,
                display: "flex",
                flexDirection: "column",
                gap: 8
            },
            children: [e.map((t, r) => n.jsx("div", {
                className: "bento-bubble",
                style: {
                    alignSelf: t.from === "agent" ? "flex-end" : "flex-start",
                    maxWidth: "82%",
                    background: t.from === "agent" ? "rgba(37,211,102,0.18)" : s.bgAlt,
                    border: `1px solid ${t.from==="agent"?"rgba(37,211,102,0.30)":s.border}`,
                    color: s.text,
                    fontSize: 12,
                    lineHeight: 1.45,
                    padding: "8px 12px",
                    borderRadius: t.from === "agent" ? "12px 12px 4px 12px" : "12px 12px 12px 4px",
                    animation: `count-up 0.4s cubic-bezier(.16,1,.3,1) ${.1+r*.12}s both`
                },
                children: t.text
            }, r)), n.jsx("div", {
                style: {
                    alignSelf: "flex-start",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    padding: "8px 12px",
                    borderRadius: 12,
                    background: s.bgAlt,
                    border: `1px solid ${s.border}`,
                    animation: "count-up 0.4s ease 0.5s both"
                },
                children: [0, 1, 2].map(t => n.jsx("span", {
                    style: {
                        width: 5,
                        height: 5,
                        borderRadius: "50%",
                        background: "#8B9AB8",
                        animation: `float-y 1.2s ease-in-out ${t*.2}s infinite`
                    }
                }, t))
            })]
        })]
    })
}

function z0() {
    return n.jsxs("div", {
        className: "bento-card",
        style: Be({
            minHeight: 280,
            display: "flex",
            flexDirection: "column"
        }),
        children: [n.jsx("h3", {
            style: Ne,
            children: "Assinatura Digital"
        }), n.jsx("p", {
            style: $e,
            children: "ClickSign e DocuSign integrados ao funil."
        }), n.jsxs("div", {
            style: {
                marginTop: 20,
                flex: 1,
                background: s.bgAlt,
                border: `1px solid ${s.border}`,
                borderRadius: 14,
                padding: 16,
                display: "flex",
                flexDirection: "column"
            },
            children: [n.jsxs("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: 10
                },
                children: [n.jsx("div", {
                    style: {
                        width: 32,
                        height: 36,
                        borderRadius: 6,
                        background: s.accentLight,
                        border: `1px solid ${s.accentBorder}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: s.accent,
                        flexShrink: 0
                    },
                    children: n.jsxs("svg", {
                        width: "18",
                        height: "18",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: [n.jsx("rect", {
                            x: "5",
                            y: "3",
                            width: "14",
                            height: "18",
                            rx: "1.5"
                        }), n.jsx("path", {
                            d: "M9 7h.01M12 7h.01M15 7h.01M9 11h.01M12 11h.01M15 11h.01M9 15h.01M12 15h.01M15 15h.01"
                        }), n.jsx("path", {
                            d: "M10 21v-3h4v3"
                        })]
                    })
                }), n.jsxs("div", {
                    style: {
                        minWidth: 0
                    },
                    children: [n.jsx("div", {
                        style: {
                            fontSize: 11.5,
                            fontWeight: 700,
                            color: s.text,
                            whiteSpace: "nowrap"
                        },
                        children: "Contrato Cliente #2847"
                    }), n.jsx("div", {
                        style: {
                            fontSize: 9.5,
                            color: s.muted,
                            marginTop: 1,
                            whiteSpace: "nowrap"
                        },
                        children: "Vertical Park · Apto 1204"
                    })]
                })]
            }), n.jsxs("div", {
                style: {
                    marginTop: 14,
                    flex: 1,
                    minHeight: 96,
                    background: s.surface,
                    border: `1.5px dashed ${s.accentBorder}`,
                    borderRadius: 10,
                    position: "relative",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: [n.jsx("svg", {
                    width: "78%",
                    height: "70%",
                    viewBox: "0 0 280 90",
                    fill: "none",
                    preserveAspectRatio: "xMidYMid meet",
                    children: n.jsx("path", {
                        className: "sign-path",
                        pathLength: "100",
                        d: "M14 60 C 26 26, 46 24, 52 52 C 56 74, 70 74, 76 50 C 82 26, 98 30, 106 54 C 114 78, 132 76, 142 50 C 154 20, 178 30, 190 54 C 198 70, 216 68, 226 46 C 234 30, 250 40, 268 40 M44 72 C 110 86, 198 86, 250 64",
                        stroke: s.accent,
                        strokeWidth: "3.4",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                }), n.jsx("span", {
                    style: {
                        position: "absolute",
                        left: 12,
                        bottom: 8,
                        fontSize: 9,
                        color: s.muted,
                        fontWeight: 600,
                        fontFamily: p
                    },
                    children: "Assinatura do comprador"
                })]
            }), n.jsxs("div", {
                style: {
                    marginTop: 14,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                    background: s.success,
                    color: "white",
                    borderRadius: 10,
                    padding: "11px 14px",
                    fontFamily: p,
                    fontSize: 13,
                    fontWeight: 800,
                    letterSpacing: .2,
                    boxShadow: `0 8px 20px ${s.success}44`
                },
                children: [n.jsx("span", {
                    style: {
                        width: 18,
                        height: 18,
                        borderRadius: "50%",
                        flexShrink: 0,
                        background: "rgba(255,255,255,0.25)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    },
                    children: n.jsx("svg", {
                        width: "11",
                        height: "11",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "white",
                        strokeWidth: "3.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: n.jsx("path", {
                            d: "M20 6 9 17l-5-5"
                        })
                    })
                }), "Assinado"]
            })]
        })]
    })
}

function M0() {
    const e = [{
            name: "João Carlos",
            duration: "04:32",
            status: "completed",
            photo: "https://randomuser.me/api/portraits/men/32.jpg"
        }, {
            name: "Ana Paula",
            duration: "Chamando",
            status: "live",
            photo: "https://randomuser.me/api/portraits/women/44.jpg"
        }, {
            name: "Mariana Souza",
            duration: "03:10",
            status: "completed",
            photo: "https://randomuser.me/api/portraits/women/65.jpg"
        }, {
            name: "Pedro Lima",
            duration: "12s",
            status: "missed",
            photo: "https://randomuser.me/api/portraits/men/45.jpg"
        }],
        t = {
            completed: "#34D399",
            live: "#5C97FF",
            missed: "#CBD5E1"
        },
        r = {
            completed: "Concluída",
            live: "Em andamento",
            missed: "Perdida"
        };
    return n.jsxs("div", {
        className: "bento-card",
        style: Be({
            minHeight: 280,
            display: "flex",
            flexDirection: "column"
        }),
        children: [n.jsxs("div", {
            style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: 14
            },
            children: [n.jsxs("div", {
                children: [n.jsx("h3", {
                    style: Ne,
                    children: "Ligação VoIP"
                }), n.jsx("p", {
                    style: $e,
                    children: "Chamadas gravadas e logadas no funil."
                })]
            }), n.jsx("div", {
                style: {
                    width: 38,
                    height: 38,
                    borderRadius: 11,
                    background: s.accentLight,
                    border: `1px solid ${s.accentBorder}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0
                },
                children: n.jsx("svg", {
                    width: "18",
                    height: "18",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: s.accent,
                    strokeWidth: "1.9",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: n.jsx("path", {
                        d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                    })
                })
            })]
        }), n.jsx("div", {
            style: {
                marginTop: 18,
                display: "flex",
                flexDirection: "column",
                gap: 8
            },
            children: e.map((o, i) => n.jsxs("div", {
                className: "bento-row",
                style: {
                    background: s.surface,
                    border: "1px solid #CBD5E1",
                    borderRadius: 11,
                    padding: "10px 12px",
                    display: "flex",
                    alignItems: "center",
                    gap: 11,
                    animation: `count-up 0.4s ease-out ${.1+i*.08}s both`
                },
                children: [n.jsxs("div", {
                    style: {
                        position: "relative",
                        flexShrink: 0
                    },
                    children: [n.jsx("img", {
                        src: o.photo,
                        alt: o.name,
                        loading: "lazy",
                        onError: a => {
                            a.currentTarget.style.visibility = "hidden"
                        },
                        style: {
                            width: 34,
                            height: 34,
                            borderRadius: "50%",
                            objectFit: "cover",
                            border: `2px solid ${s.surface}`,
                            boxShadow: "0 2px 6px rgba(10,15,30,0.15)"
                        }
                    }), n.jsx("span", {
                        style: {
                            position: "absolute",
                            bottom: -1,
                            right: -1,
                            width: 15,
                            height: 15,
                            borderRadius: "50%",
                            background: t[o.status],
                            border: `2px solid ${s.surface}`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        },
                        children: o.status === "missed" ? n.jsxs("svg", {
                            width: "8",
                            height: "8",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "white",
                            strokeWidth: "3",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: [n.jsx("path", {
                                d: "M23 6l-9.5 9.5-5-5L1 18"
                            }), n.jsx("polyline", {
                                points: "17 6 23 6 23 12"
                            })]
                        }) : o.status === "live" ? n.jsx("span", {
                            className: "pulse-dot",
                            style: {
                                width: 6,
                                height: 6,
                                borderRadius: "50%",
                                background: "white",
                                display: "inline-block"
                            }
                        }) : n.jsx("svg", {
                            width: "8",
                            height: "8",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "white",
                            strokeWidth: "3.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: n.jsx("polyline", {
                                points: "20 6 9 17 4 12"
                            })
                        })
                    })]
                }), n.jsxs("div", {
                    style: {
                        flex: 1,
                        minWidth: 0
                    },
                    children: [n.jsx("div", {
                        style: {
                            fontSize: 11.5,
                            fontWeight: 700,
                            color: s.text,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        },
                        children: o.name
                    }), n.jsx("div", {
                        style: {
                            fontSize: 9.5,
                            color: s.muted,
                            marginTop: 1
                        },
                        children: r[o.status]
                    })]
                }), n.jsx("span", {
                    style: {
                        fontSize: 11,
                        fontWeight: 800,
                        color: t[o.status],
                        fontFamily: p,
                        whiteSpace: "nowrap"
                    },
                    children: o.duration
                })]
            }, i))
        })]
    })
}

function R0() {
    const e = [{
            name: "Novo",
            count: 47,
            color: "#8FB3E6"
        }, {
            name: "Qualificação",
            count: 28,
            color: "#6F93C7"
        }, {
            name: "Proposta",
            count: 14,
            color: "#98A4B6"
        }, {
            name: "Fechado",
            count: 8,
            color: "#5B7BA6"
        }],
        [t, r] = b.useState(0);
    return b.useEffect(() => {
        const o = setInterval(() => r(i => (i + 1) % 4), 1600);
        return () => clearInterval(o)
    }, []), n.jsxs("div", {
        className: "bento-card",
        style: Be({
            minHeight: 280,
            display: "flex",
            flexDirection: "column"
        }),
        children: [n.jsx(Vn, {
            color: "#5C97FF",
            x: "92%",
            y: "14%",
            size: 240,
            opacity: .2
        }), n.jsx("h3", {
            style: Ne,
            children: "Funil de Vendas"
        }), n.jsx("p", {
            style: $e,
            children: "Pipeline com gestão de leads por etapa"
        }), n.jsx("div", {
            style: {
                marginTop: 22,
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: 6
            },
            children: e.map((o, i) => n.jsxs("div", {
                style: {
                    background: s.surface,
                    border: "1px solid #CBD5E1",
                    borderRadius: 8,
                    padding: "8px 6px",
                    display: "flex",
                    flexDirection: "column",
                    gap: 5,
                    minHeight: 142,
                    animation: `count-up 0.4s ease-out ${i*.06}s both`
                },
                children: [n.jsxs("div", {
                    style: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0 2px 6px"
                    },
                    children: [n.jsx("span", {
                        style: {
                            fontSize: 9,
                            fontWeight: 800,
                            color: o.color,
                            letterSpacing: .3,
                            textTransform: "uppercase",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        },
                        children: o.name
                    }), n.jsx("span", {
                        style: {
                            fontSize: 8.5,
                            fontWeight: 800,
                            color: o.color,
                            background: `${o.color}1F`,
                            padding: "1px 5px",
                            borderRadius: 4
                        },
                        children: o.count
                    })]
                }), i === t && n.jsxs("div", {
                    style: {
                        background: s.surface,
                        border: `1.5px solid ${o.color}`,
                        borderRadius: 5,
                        padding: "5px 6px",
                        boxShadow: `0 6px 14px ${o.color}55`,
                        animation: "lead-in 0.5s cubic-bezier(.16,1,.3,1)"
                    },
                    children: [n.jsxs("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            gap: 4
                        },
                        children: [n.jsx("div", {
                            style: {
                                width: 14,
                                height: 14,
                                borderRadius: 4,
                                background: o.color,
                                fontSize: 7,
                                fontWeight: 800,
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0
                            },
                            children: "L"
                        }), n.jsx("div", {
                            style: {
                                height: 4,
                                flex: 1,
                                background: `${o.color}55`,
                                borderRadius: 2
                            }
                        })]
                    }), n.jsx("div", {
                        style: {
                            height: 3,
                            marginTop: 4,
                            background: o.color,
                            width: "72%",
                            borderRadius: 2,
                            opacity: .7
                        }
                    })]
                }, t), Array.from({
                    length: Math.min(3, o.count)
                }).map((a, l) => n.jsxs("div", {
                    className: "bento-row",
                    style: {
                        background: s.bgAlt,
                        border: `1px solid ${s.border}`,
                        borderRadius: 5,
                        padding: "5px 6px",
                        animation: `count-up 0.35s ease ${.2+i*.06+l*.04}s both`
                    },
                    children: [n.jsxs("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            gap: 4
                        },
                        children: [n.jsx("div", {
                            style: {
                                width: 14,
                                height: 14,
                                borderRadius: 4,
                                background: `linear-gradient(135deg, ${o.color}, ${o.color}88)`,
                                fontSize: 7,
                                fontWeight: 800,
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0
                            },
                            children: String.fromCharCode(65 + i + l)
                        }), n.jsx("div", {
                            style: {
                                height: 4,
                                flex: 1,
                                background: s.bgDeep,
                                borderRadius: 2
                            }
                        })]
                    }), n.jsx("div", {
                        style: {
                            height: 3,
                            marginTop: 4,
                            background: o.color,
                            width: `${50+l*16}%`,
                            borderRadius: 2,
                            opacity: .5
                        }
                    })]
                }, l))]
            }, o.name))
        })]
    })
}

function I0() {
    const e = [
        ["Apto 1204", "R$ 680.000"],
        ["Desconto −3%", "−R$ 20.400"],
        ["Subtotal", "R$ 659.600"]
    ];
    return n.jsxs("div", {
        className: "bento-card",
        style: Be({
            minHeight: 280,
            display: "flex",
            flexDirection: "column"
        }),
        children: [n.jsx("h3", {
            style: Ne,
            children: "Simulador/Proposta"
        }), n.jsx("p", {
            style: $e,
            children: "Proposta com desconto e simulação de parcelas em 1 clique."
        }), n.jsxs("div", {
            className: "feat-row",
            style: {
                marginTop: 22,
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 16,
                flex: 1
            },
            children: [n.jsxs("div", {
                style: {
                    minWidth: 0,
                    background: s.surface,
                    border: `1px solid ${s.border}`,
                    borderRadius: 11,
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column"
                },
                children: [n.jsxs("div", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        minWidth: 0,
                        padding: "11px 13px",
                        borderBottom: `1px solid ${s.border}`,
                        background: s.surface
                    },
                    children: [n.jsx("div", {
                        style: {
                            width: 28,
                            height: 30,
                            borderRadius: 6,
                            flexShrink: 0,
                            background: s.accentLight,
                            border: `1px solid ${s.accentBorder}`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: s.accent
                        },
                        children: n.jsxs("svg", {
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "1.8",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: [n.jsx("rect", {
                                x: "5",
                                y: "3",
                                width: "14",
                                height: "18",
                                rx: "1.5"
                            }), n.jsx("path", {
                                d: "M9 7h.01M12 7h.01M15 7h.01M9 11h.01M12 11h.01M15 11h.01M9 15h.01M12 15h.01M15 15h.01"
                            }), n.jsx("path", {
                                d: "M10 21v-3h4v3"
                            })]
                        })
                    }), n.jsxs("div", {
                        style: {
                            minWidth: 0
                        },
                        children: [n.jsx("div", {
                            style: {
                                fontSize: 11.5,
                                fontWeight: 800,
                                color: s.text,
                                whiteSpace: "nowrap"
                            },
                            children: "Proposta #2847"
                        }), n.jsx("div", {
                            style: {
                                fontSize: 9.5,
                                color: s.muted,
                                marginTop: 1,
                                whiteSpace: "nowrap"
                            },
                            children: "Vertical Park"
                        })]
                    })]
                }), n.jsxs("div", {
                    style: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "7px 13px",
                        borderBottom: `1px solid ${s.border}`,
                        background: s.bgAlt
                    },
                    children: [n.jsx("span", {
                        style: {
                            fontSize: 8.5,
                            fontWeight: 800,
                            letterSpacing: .8,
                            textTransform: "uppercase",
                            color: s.muted
                        },
                        children: "Descrição"
                    }), n.jsx("span", {
                        style: {
                            fontSize: 8.5,
                            fontWeight: 800,
                            letterSpacing: .8,
                            textTransform: "uppercase",
                            color: s.muted
                        },
                        children: "Valor"
                    })]
                }), n.jsx("div", {
                    style: {
                        flex: 1
                    },
                    children: e.map(([t, r], o) => n.jsxs("div", {
                        className: "bento-row",
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "8px 13px",
                            fontSize: 11.5,
                            borderBottom: `1px solid ${s.border}`,
                            background: o % 2 === 1 ? s.bgAlt : "transparent",
                            animation: `count-up 0.4s ease ${.1+o*.08}s both`
                        },
                        children: [n.jsxs("span", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                minWidth: 0
                            },
                            children: [n.jsx("span", {
                                style: {
                                    width: 16,
                                    height: 16,
                                    borderRadius: 4,
                                    flexShrink: 0,
                                    background: s.accentLight,
                                    color: s.accent,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontFamily: Pt,
                                    fontSize: 8,
                                    fontWeight: 800
                                },
                                children: String(o + 1).padStart(2, "0")
                            }), n.jsx("span", {
                                style: {
                                    color: s.muted,
                                    fontFamily: p,
                                    whiteSpace: "nowrap"
                                },
                                children: t
                            })]
                        }), n.jsx("span", {
                            style: {
                                color: s.text,
                                fontWeight: 700,
                                fontFamily: Pt
                            },
                            children: r
                        })]
                    }, o))
                }), n.jsxs("div", {
                    style: {
                        marginTop: "auto",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "11px 13px",
                        background: s.accentLight,
                        borderTop: `1px solid ${s.accentBorder}`
                    },
                    children: [n.jsx("span", {
                        style: {
                            fontSize: 11,
                            color: s.muted,
                            fontWeight: 700
                        },
                        children: "Valor final"
                    }), n.jsx("span", {
                        style: {
                            fontSize: 18,
                            fontWeight: 800,
                            color: s.accent,
                            fontFamily: Pt,
                            letterSpacing: -.4
                        },
                        children: "R$ 659.600"
                    })]
                })]
            }), n.jsxs("div", {
                style: {
                    minWidth: 0,
                    display: "flex",
                    flexDirection: "column",
                    gap: 10
                },
                children: [n.jsxs("div", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        gap: 9
                    },
                    children: [n.jsx("img", {
                        src: "https://randomuser.me/api/portraits/women/65.jpg",
                        alt: "Gabriela Faquener",
                        loading: "lazy",
                        style: {
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                            objectFit: "cover",
                            flexShrink: 0,
                            border: `2px solid ${s.surface}`,
                            boxShadow: "0 2px 8px rgba(10,15,30,0.15)"
                        }
                    }), n.jsxs("div", {
                        style: {
                            minWidth: 0
                        },
                        children: [n.jsx("div", {
                            style: {
                                fontSize: 12,
                                fontWeight: 800,
                                color: s.text,
                                whiteSpace: "nowrap"
                            },
                            children: "Gabriela Faquener"
                        }), n.jsx("div", {
                            style: {
                                fontSize: 10,
                                color: s.muted,
                                marginTop: 1
                            },
                            children: "Cliente"
                        })]
                    })]
                }), n.jsxs("div", {
                    style: {
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 7,
                        alignSelf: "flex-start",
                        background: s.accentLight,
                        border: `1px solid ${s.accentBorder}`,
                        borderRadius: 8,
                        padding: "6px 11px"
                    },
                    children: [n.jsxs("svg", {
                        width: "13",
                        height: "13",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: s.accent,
                        strokeWidth: "1.9",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: [n.jsx("rect", {
                            x: "5",
                            y: "3",
                            width: "14",
                            height: "18",
                            rx: "1.5"
                        }), n.jsx("path", {
                            d: "M10 21v-3h4v3"
                        })]
                    }), n.jsx("span", {
                        style: {
                            fontSize: 10.5,
                            fontWeight: 700,
                            color: s.text
                        },
                        children: "Pró-Soluto"
                    }), n.jsx("span", {
                        style: {
                            fontSize: 10.5,
                            fontWeight: 800,
                            color: s.accent,
                            fontFamily: p
                        },
                        children: "R$ 17.890,00"
                    })]
                }), n.jsxs("div", {
                    style: {
                        background: s.surface,
                        border: "1px solid #CBD5E1",
                        borderRadius: 12,
                        padding: "11px 14px"
                    },
                    children: [n.jsxs("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 9
                        },
                        children: [n.jsx("span", {
                            style: {
                                fontSize: 11.5,
                                color: s.muted,
                                fontWeight: 600
                            },
                            children: "Entrada"
                        }), n.jsx("span", {
                            style: {
                                fontSize: 12,
                                color: s.text,
                                fontWeight: 800,
                                fontFamily: p,
                                letterSpacing: -.2
                            },
                            children: "20% · R$ 131.920"
                        })]
                    }), n.jsxs("div", {
                        style: {
                            height: 5,
                            background: s.bgAlt,
                            borderRadius: 3,
                            position: "relative",
                            overflow: "hidden"
                        },
                        children: [n.jsx("div", {
                            className: "bar-grow bento-bar",
                            style: {
                                width: "20%",
                                height: 5,
                                background: s.accent,
                                borderRadius: 3
                            }
                        }), n.jsx("span", {
                            style: {
                                position: "absolute",
                                left: "20%",
                                top: "50%",
                                width: 13,
                                height: 13,
                                borderRadius: "50%",
                                background: "white",
                                border: `2px solid ${s.accent}`,
                                transform: "translate(-50%, -50%)",
                                boxShadow: `0 2px 6px ${s.accent}66`
                            }
                        })]
                    })]
                }), n.jsxs("div", {
                    style: {
                        background: s.surface,
                        border: "1px solid #CBD5E1",
                        borderRadius: 12,
                        padding: "11px 14px"
                    },
                    children: [n.jsxs("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 9
                        },
                        children: [n.jsx("span", {
                            style: {
                                fontSize: 11.5,
                                color: s.muted,
                                fontWeight: 600
                            },
                            children: "Parcelamento"
                        }), n.jsx("span", {
                            style: {
                                fontSize: 12,
                                color: s.text,
                                fontWeight: 800,
                                fontFamily: p,
                                letterSpacing: -.2
                            },
                            children: "60 meses · INCC"
                        })]
                    }), n.jsxs("div", {
                        style: {
                            height: 5,
                            background: s.bgAlt,
                            borderRadius: 3,
                            position: "relative",
                            overflow: "hidden"
                        },
                        children: [n.jsx("div", {
                            className: "bar-grow bento-bar",
                            style: {
                                width: "50%",
                                height: 5,
                                background: s.success,
                                borderRadius: 3,
                                animationDelay: "0.2s"
                            }
                        }), n.jsx("span", {
                            style: {
                                position: "absolute",
                                left: "50%",
                                top: "50%",
                                width: 13,
                                height: 13,
                                borderRadius: "50%",
                                background: "white",
                                border: `2px solid ${s.success}`,
                                transform: "translate(-50%, -50%)",
                                boxShadow: `0 2px 6px ${s.success}66`
                            }
                        })]
                    })]
                }), n.jsxs("div", {
                    style: {
                        marginTop: "auto",
                        background: s.surface,
                        border: "1px solid #CBD5E1",
                        borderRadius: 12,
                        padding: "13px 15px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        boxShadow: "0 6px 18px rgba(10,15,30,0.06)"
                    },
                    children: [n.jsxs("div", {
                        children: [n.jsx("div", {
                            style: {
                                fontSize: 10,
                                color: s.muted,
                                fontWeight: 700,
                                letterSpacing: .4,
                                textTransform: "uppercase"
                            },
                            children: "Parcela mensal"
                        }), n.jsx("div", {
                            style: {
                                fontSize: 21,
                                fontWeight: 800,
                                color: s.text,
                                marginTop: 3,
                                letterSpacing: -.6,
                                fontFamily: p
                            },
                            children: "R$ 8.793"
                        })]
                    }), n.jsxs("div", {
                        style: {
                            textAlign: "right"
                        },
                        children: [n.jsx("div", {
                            style: {
                                fontSize: 10,
                                color: s.muted,
                                fontWeight: 700,
                                letterSpacing: .4,
                                textTransform: "uppercase"
                            },
                            children: "CET"
                        }), n.jsx("div", {
                            style: {
                                fontSize: 13.5,
                                fontWeight: 800,
                                color: s.success,
                                marginTop: 3,
                                fontFamily: p
                            },
                            children: "0,8% a.m."
                        })]
                    })]
                })]
            })]
        })]
    })
}
const T0 = {
    ligacao: {
        label: "Ligação",
        color: "#5C97FF",
        icon: n.jsx("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: n.jsx("path", {
                d: "M5 3h4l2 5-3 2a12 12 0 0 0 5 5l2-3 5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 5a2 2 0 0 1 2-2z"
            })
        })
    },
    whatsapp: {
        label: "WhatsApp",
        color: "#25D366",
        icon: n.jsx("svg", {
            width: "15",
            height: "15",
            viewBox: "0 0 24 24",
            fill: "currentColor",
            children: n.jsx("path", {
                d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347M12.05 21.785a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884"
            })
        })
    },
    visita: {
        label: "Visita",
        color: "#0560FF",
        icon: n.jsxs("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [n.jsx("path", {
                d: "M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"
            }), n.jsx("circle", {
                cx: "12",
                cy: "10",
                r: "3"
            })]
        })
    },
    email: {
        label: "E-mail",
        color: "#94A3B8",
        icon: n.jsxs("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [n.jsx("rect", {
                x: "3",
                y: "5",
                width: "18",
                height: "14",
                rx: "2"
            }), n.jsx("path", {
                d: "m3 7 9 6 9-6"
            })]
        })
    }
};

function W0() {
    const e = [{
        type: "ligacao",
        text: "Ligar para João Carlos · #2847",
        when: "Hoje · 14h",
        done: !0,
        photo: "https://randomuser.me/api/portraits/men/32.jpg"
    }, {
        type: "whatsapp",
        text: "WhatsApp Ana Paula · proposta",
        when: "Hoje · 17h",
        priority: !0,
        photo: "https://randomuser.me/api/portraits/women/44.jpg"
    }, {
        type: "visita",
        text: "Visita ao Apto 1204 · Marina",
        when: "Amanhã · 10h",
        photo: "https://randomuser.me/api/portraits/men/32.jpg"
    }, {
        type: "email",
        text: "E-mail de follow-up · Pedro",
        when: "06/06",
        photo: "https://randomuser.me/api/portraits/women/68.jpg"
    }];
    return n.jsxs("div", {
        className: "bento-card",
        style: Be({
            minHeight: 280,
            display: "flex",
            flexDirection: "column"
        }),
        children: [n.jsxs("div", {
            style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: 14
            },
            children: [n.jsxs("div", {
                children: [n.jsx("h3", {
                    style: Ne,
                    children: "Gestão de Tarefas"
                }), n.jsx("p", {
                    style: $e,
                    children: "Atribuídas ao funil, com SLA e lembretes."
                })]
            }), n.jsx("div", {
                style: {
                    fontFamily: p,
                    fontSize: 11,
                    color: s.muted,
                    fontWeight: 800,
                    background: s.bgAlt,
                    padding: "4px 9px",
                    borderRadius: 6,
                    border: `1px solid ${s.border}`,
                    whiteSpace: "nowrap"
                },
                children: "3 de 4"
            })]
        }), n.jsx("div", {
            style: {
                marginTop: 18,
                display: "flex",
                flexDirection: "column",
                gap: 8
            },
            children: e.map((t, r) => {
                const o = T0[t.type];
                return n.jsxs("div", {
                    className: "bento-row",
                    style: {
                        background: s.surface,
                        border: "1px solid #CBD5E1",
                        borderRadius: 11,
                        padding: "10px 12px",
                        display: "flex",
                        alignItems: "center",
                        gap: 11,
                        animation: `count-up 0.4s ease-out ${.1+r*.06}s both`
                    },
                    children: [n.jsx("span", {
                        style: {
                            width: 18,
                            height: 18,
                            borderRadius: 5,
                            flexShrink: 0,
                            background: t.done ? s.success : s.surface,
                            border: `1.5px solid ${t.done?s.success:"#CBD5E1"}`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        },
                        children: t.done && n.jsx("svg", {
                            width: "10",
                            height: "10",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "white",
                            strokeWidth: "3.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: n.jsx("polyline", {
                                points: "20 6 9 17 4 12"
                            })
                        })
                    }), n.jsx("span", {
                        style: {
                            width: 30,
                            height: 30,
                            borderRadius: 9,
                            flexShrink: 0,
                            background: `${o.color}1A`,
                            color: o.color,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        },
                        children: o.icon
                    }), n.jsxs("div", {
                        style: {
                            flex: 1,
                            minWidth: 0
                        },
                        children: [n.jsx("div", {
                            style: {
                                fontSize: 11.5,
                                fontWeight: 700,
                                color: t.done ? s.muted : s.text,
                                textDecoration: t.done ? "line-through" : "none",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            },
                            children: t.text
                        }), n.jsxs("div", {
                            style: {
                                fontSize: 10,
                                color: s.muted,
                                marginTop: 2,
                                fontFamily: p
                            },
                            children: [o.label, " · ", t.when]
                        })]
                    }), t.priority && n.jsx("span", {
                        style: {
                            fontSize: 9,
                            fontWeight: 800,
                            color: "#E8915B",
                            background: "rgba(232,145,91,0.14)",
                            border: "1px solid rgba(232,145,91,0.4)",
                            padding: "2px 7px",
                            borderRadius: 5,
                            whiteSpace: "nowrap"
                        },
                        children: "Urgente"
                    }), n.jsx("img", {
                        src: t.photo,
                        alt: t.name,
                        loading: "lazy",
                        onError: i => {
                            i.currentTarget.style.visibility = "hidden"
                        },
                        style: {
                            width: 28,
                            height: 28,
                            borderRadius: "50%",
                            objectFit: "cover",
                            flexShrink: 0,
                            border: `2px solid ${s.surface}`,
                            boxShadow: "0 2px 6px rgba(10,15,30,0.15)"
                        }
                    })]
                }, r)
            })
        })]
    })
}

function A0() {
    return n.jsxs("div", {
        className: "bento-card",
        style: Be({
            minHeight: 280,
            display: "flex",
            flexDirection: "column"
        }),
        children: [n.jsx(Vn, {
            color: "#0560FF",
            x: "92%",
            y: "14%",
            size: 240,
            opacity: .2
        }), n.jsx("div", {
            style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: 14
            },
            children: n.jsxs("div", {
                children: [n.jsx("h3", {
                    style: Ne,
                    children: "Dashboard Personalizável"
                }), n.jsx("p", {
                    style: $e,
                    children: "Widgets reorganizáveis por perfil e empresa."
                })]
            })
        }), n.jsxs("div", {
            style: {
                marginTop: 18,
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 8,
                flex: 1
            },
            children: [n.jsxs("div", {
                className: "bento-row",
                style: {
                    background: s.surface,
                    border: `1px dashed ${s.accentBorder}`,
                    borderRadius: 10,
                    padding: "12px 14px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    animation: "count-up 0.4s ease 0.1s both"
                },
                children: [n.jsxs("div", {
                    style: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    },
                    children: [n.jsx("span", {
                        style: {
                            fontSize: 10,
                            color: s.muted,
                            fontWeight: 800,
                            letterSpacing: .4,
                            textTransform: "uppercase"
                        },
                        children: "VGV Total"
                    }), n.jsx("span", {
                        style: {
                            fontSize: 11,
                            color: s.success,
                            fontWeight: 800
                        },
                        children: "↑ 9%"
                    })]
                }), n.jsx("div", {
                    style: {
                        fontSize: 22,
                        fontWeight: 800,
                        color: s.text,
                        letterSpacing: -.6,
                        marginTop: 6,
                        fontFamily: p
                    },
                    children: "R$ 48,6M"
                }), n.jsx("div", {
                    style: {
                        fontSize: 9.5,
                        color: s.muted,
                        fontWeight: 600,
                        marginTop: 2
                    },
                    children: "acumulado no ano"
                })]
            }), n.jsxs("div", {
                className: "bento-row",
                style: {
                    background: s.surface,
                    border: `1px dashed ${s.accentBorder}`,
                    borderRadius: 10,
                    padding: "12px 14px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    animation: "count-up 0.4s ease 0.18s both"
                },
                children: [n.jsxs("div", {
                    style: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    },
                    children: [n.jsx("span", {
                        style: {
                            fontSize: 10,
                            color: s.muted,
                            fontWeight: 800,
                            letterSpacing: .4,
                            textTransform: "uppercase"
                        },
                        children: "VGV Mês"
                    }), n.jsx("span", {
                        style: {
                            fontSize: 11,
                            color: s.success,
                            fontWeight: 800
                        },
                        children: "↑ 18%"
                    })]
                }), n.jsx("div", {
                    style: {
                        fontSize: 22,
                        fontWeight: 800,
                        color: s.text,
                        letterSpacing: -.6,
                        marginTop: 6,
                        fontFamily: p
                    },
                    children: "R$ 4,2M"
                }), n.jsx("div", {
                    style: {
                        fontSize: 9.5,
                        color: s.muted,
                        fontWeight: 600,
                        marginTop: 2
                    },
                    children: "junho · 68% da meta"
                })]
            }), n.jsxs("div", {
                className: "bento-row",
                style: {
                    background: s.surface,
                    border: `1px dashed ${s.accentBorder}`,
                    borderRadius: 10,
                    padding: "12px 14px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    animation: "count-up 0.4s ease 0.26s both"
                },
                children: [n.jsxs("div", {
                    style: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    },
                    children: [n.jsx("span", {
                        style: {
                            fontSize: 10,
                            color: s.muted,
                            fontWeight: 800,
                            letterSpacing: .4,
                            textTransform: "uppercase"
                        },
                        children: "Volume de Leads"
                    }), n.jsx("span", {
                        style: {
                            fontSize: 14,
                            color: s.text,
                            fontWeight: 800,
                            fontFamily: p
                        },
                        children: "247"
                    })]
                }), n.jsxs("svg", {
                    viewBox: "0 0 100 46",
                    preserveAspectRatio: "none",
                    style: {
                        width: "100%",
                        height: 58,
                        marginTop: 8,
                        display: "block"
                    },
                    children: [n.jsx("defs", {
                        children: n.jsxs("linearGradient", {
                            id: "leadsGrad",
                            x1: "0",
                            y1: "0",
                            x2: "0",
                            y2: "1",
                            children: [n.jsx("stop", {
                                offset: "0%",
                                stopColor: s.accent,
                                stopOpacity: "0.32"
                            }), n.jsx("stop", {
                                offset: "100%",
                                stopColor: s.accent,
                                stopOpacity: "0"
                            })]
                        })
                    }), n.jsx("polyline", {
                        points: "0,36 14,31 28,38 42,20 56,27 70,11 84,16 100,4 100,46 0,46",
                        fill: "url(#leadsGrad)",
                        stroke: "none"
                    }), n.jsx("polyline", {
                        points: "0,36 14,31 28,38 42,20 56,27 70,11 84,16 100,4",
                        fill: "none",
                        stroke: s.accent,
                        strokeWidth: "2.6",
                        vectorEffect: "non-scaling-stroke",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }), n.jsx("circle", {
                        cx: "100",
                        cy: "4",
                        r: "3.4",
                        fill: s.accent,
                        vectorEffect: "non-scaling-stroke"
                    })]
                })]
            }), n.jsxs("div", {
                className: "bento-row",
                style: {
                    background: s.surface,
                    border: `1px dashed ${s.accentBorder}`,
                    borderRadius: 10,
                    padding: "12px 14px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    animation: "count-up 0.4s ease 0.34s both"
                },
                children: [n.jsxs("div", {
                    style: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    },
                    children: [n.jsx("span", {
                        style: {
                            fontSize: 10,
                            color: s.muted,
                            fontWeight: 800,
                            letterSpacing: .4,
                            textTransform: "uppercase"
                        },
                        children: "Unidades vendidas"
                    }), n.jsx("span", {
                        style: {
                            fontSize: 11,
                            color: s.success,
                            fontWeight: 800
                        },
                        children: "↑ 6"
                    })]
                }), n.jsxs("div", {
                    style: {
                        display: "flex",
                        alignItems: "baseline",
                        gap: 5,
                        marginTop: 6
                    },
                    children: [n.jsx("span", {
                        style: {
                            fontSize: 22,
                            fontWeight: 800,
                            color: s.text,
                            letterSpacing: -.6,
                            fontFamily: p
                        },
                        children: "32"
                    }), n.jsx("span", {
                        style: {
                            fontSize: 11,
                            color: s.muted,
                            fontWeight: 700
                        },
                        children: "/ 120 un."
                    })]
                }), n.jsx("div", {
                    style: {
                        height: 4,
                        background: s.surface,
                        borderRadius: 3,
                        overflow: "hidden",
                        marginTop: 6
                    },
                    children: n.jsx("div", {
                        className: "bar-grow bento-bar",
                        style: {
                            width: "27%",
                            height: 4,
                            background: s.success,
                            borderRadius: 3
                        }
                    })
                })]
            })]
        })]
    })
}
const or = [R0, b0, I0, k0, S0, C0, E0, z0, F0, M0, W0, A0];

function al() {
    const [e, t] = b.useState(0), r = or.length, o = (e - 1 + r) % r, i = (e + 1) % r, a = or[e], l = or[o], d = or[i], c = "min(620px, 88vw)", u = g => t((g % r + r) % r), m = g => t(v => ((v + g) % r + r) % r);
    return n.jsxs("section", {
        id: "ecossistema",
        "data-screen-label": "04 Ecossistema",
        style: {
            background: s.surface,
            position: "relative",
            overflow: "hidden",
            padding: "88px 0 96px"
        },
        children: [n.jsx("div", {
            className: "grid-bg",
            style: {
                position: "absolute",
                inset: 0,
                opacity: .4,
                maskImage: "radial-gradient(ellipse 70% 60% at 50% 50%, black 0%, transparent 80%)",
                WebkitMaskImage: "radial-gradient(ellipse 70% 60% at 50% 50%, black 0%, transparent 80%)",
                pointerEvents: "none"
            }
        }), n.jsxs("div", {
            style: {
                position: "relative",
                zIndex: 1,
                width: "100%",
                maxWidth: 1280,
                margin: "0 auto",
                padding: "0 28px"
            },
            children: [n.jsxs("div", {
                style: {
                    textAlign: "center",
                    marginBottom: 20
                },
                children: [n.jsxs("h2", {
                    className: "eco-title",
                    style: {
                        fontFamily: p,
                        fontSize: 42,
                        fontWeight: 800,
                        lineHeight: 1.08,
                        letterSpacing: -1.6,
                        color: s.text,
                        margin: "0 auto",
                        maxWidth: 780
                    },
                    children: ["A Solução completa ", n.jsx("span", {
                        style: {
                            color: s.muted
                        },
                        children: "em uma única Plataforma."
                    })]
                }), n.jsx("p", {
                    style: {
                        fontFamily: p,
                        fontSize: 14.5,
                        color: s.muted,
                        maxWidth: 660,
                        margin: "14px auto 0",
                        lineHeight: 1.55
                    },
                    children: "Seu processo de vendas e financeiro 100% integrado — sem retrabalho, sem planilha intermediária, sem dados desencontrados."
                })]
            }), n.jsx("div", {
                style: {
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    gap: 9,
                    marginBottom: 30
                },
                children: or.map((g, v) => {
                    const y = v === e;
                    return n.jsx("button", {
                        onClick: () => u(v),
                        "aria-label": `Módulo ${v+1}`,
                        className: "eco-dot",
                        style: {
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                            cursor: "pointer",
                            fontFamily: p,
                            fontSize: 13,
                            fontWeight: 800,
                            flexShrink: 0,
                            background: y ? s.accent : s.surface,
                            color: y ? "white" : s.muted,
                            border: `1.5px solid ${y?s.accent:s.border}`,
                            boxShadow: y ? `0 6px 16px ${s.accent}44` : "none",
                            transition: "background 0.2s, color 0.2s, border-color 0.2s"
                        },
                        children: v + 1
                    }, v)
                })
            })]
        }), n.jsxs("div", {
            style: {
                position: "relative",
                width: "100%",
                maxWidth: 1280,
                margin: "0 auto",
                padding: "0 28px"
            },
            children: [
                [-1, 1].map(g => n.jsx("button", {
                    onClick: () => m(g),
                    "aria-label": g < 0 ? "Anterior" : "Próximo",
                    className: "eco-arrow",
                    style: {
                        position: "absolute",
                        top: "50%",
                        zIndex: 6,
                        [g < 0 ? "left" : "right"]: 18,
                        transform: "translateY(-50%)",
                        width: 52,
                        height: 52,
                        borderRadius: "50%",
                        cursor: "pointer",
                        background: s.surface,
                        border: `1.5px solid ${s.border}`,
                        color: s.text,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 8px 24px rgba(10,15,30,0.12)",
                        transition: "background 0.2s, color 0.2s, border-color 0.2s"
                    },
                    onMouseEnter: v => {
                        v.currentTarget.style.background = s.accent, v.currentTarget.style.color = "white", v.currentTarget.style.borderColor = s.accent
                    },
                    onMouseLeave: v => {
                        v.currentTarget.style.background = s.surface, v.currentTarget.style.color = s.text, v.currentTarget.style.borderColor = s.border
                    },
                    children: n.jsx("svg", {
                        width: "22",
                        height: "22",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "2.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: g < 0 ? n.jsx("path", {
                            d: "M15 18l-6-6 6-6"
                        }) : n.jsx("path", {
                            d: "M9 18l6-6-6-6"
                        })
                    })
                }, g)), n.jsx("div", {
                    onClick: () => u(o),
                    "aria-hidden": "true",
                    className: "eco-peek",
                    style: {
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: c,
                        transform: "translate(-50%, -50%) translateX(-61%) scale(0.85)",
                        opacity: .34,
                        zIndex: 1,
                        cursor: "pointer",
                        transition: "transform 0.55s cubic-bezier(.16,1,.3,1), opacity 0.55s"
                    },
                    children: n.jsx(l, {})
                }), n.jsx("div", {
                    onClick: () => u(i),
                    "aria-hidden": "true",
                    className: "eco-peek",
                    style: {
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: c,
                        transform: "translate(-50%, -50%) translateX(61%) scale(0.85)",
                        opacity: .34,
                        zIndex: 1,
                        cursor: "pointer",
                        transition: "transform 0.55s cubic-bezier(.16,1,.3,1), opacity 0.55s"
                    },
                    children: n.jsx(d, {})
                }), n.jsx("div", {
                    className: "esteira-active",
                    style: {
                        position: "relative",
                        zIndex: 3,
                        width: c,
                        margin: "0 auto"
                    },
                    children: n.jsx(a, {})
                }, e)
            ]
        })]
    })
}

const Ci = [{
    quote: "A assinatura digital reduziu nosso ciclo de fechamento. O cliente assina pelo celular, na hora — sem reunião presencial.",
    company: "Terrano",
    uf: "Goiânia · GO",
    logo: "/assets/clientes/terrano.png",
    logoHeight: 24,
    metric: "+38% em conversão"
}, {
    quote: "A aprovação automática de reservas liberou nosso comercial pra focar no que importa e reduziu bastante o retrabalho operacional.",
    company: "Alefir Urbanismo",
    uf: "Presidente Prudente · SP",
    logo: "/assets/clientes/alefir.png",
    logoHeight: 26,
    metric: "−70% retrabalho"
}, {
    quote: "Em poucas semanas estávamos operando 100% — ERP integrado, time treinado e leads no funil. Implantação diferenciada.",
    company: "FRSC",
    uf: "Anápolis · GO",
    logo: "/assets/clientes/frsc.png",
    logoHeight: 30,
    metric: "Implantação ágil"
}, {
    quote: "Centralizamos tudo no IMOBMEET. O time vê o funil completo em tempo real e o financeiro recebe a venda automaticamente.",
    company: "PEMI",
    uf: "Lavras · MG",
    logo: "/assets/clientes/pemi.png",
    logoHeight: 30,
    metric: "Gestão centralizada"
}, {
    quote: "Passamos por vários CRMs imobiliários, mas somente o IMOBMEET nos atendeu ponta a ponta e com suporte humanizado.",
    company: "GTG",
    uf: "Francisco Beltrão · PR",
    logo: "/assets/clientes/gtg.png",
    logoHeight: 30,
    metric: "Atendimento ponta a ponta"
}, {
    quote: "Gestão de recebíveis com emissão de boletos e conciliação dentro do próprio CRM. Menos inadimplência e muito mais controle.",
    company: "Engecom",
    uf: "Anápolis · GO",
    logo: "/assets/clientes/engecom.png",
    logoHeight: 30,
    metric: "Financeiro no controle"
}, {
    quote: "Unificamos vendas, reservas e financeiro no IMOBMEET. A equipe ganhou agilidade e a diretoria acompanha os resultados em tempo real.",
    company: "Emisa Incorporadora",
    uf: "Belo Horizonte · MG",
    logo: "/assets/clientes/emisa.png",
    logoHeight: 34,
    metric: "Operação unificada"
}, {
    quote: "Do primeiro contato ao pós-venda, tudo roda no IMOBMEET. Ganhamos previsibilidade e o comercial trabalha muito mais focado.",
    company: "Bricatte Incorporações",
    uf: "Goiânia · GO",
    logo: "/assets/clientes/bricatte.png",
    logoHeight: 26,
    metric: "Previsibilidade nas vendas"
}, {
    quote: "A integração entre vendas e financeiro eliminou retrabalho. Emitimos boletos e acompanhamos os recebíveis sem sair do CRM.",
    company: "L. Furtado Construtora",
    uf: "Anápolis · GO",
    logo: "/assets/clientes/lfurtado.png",
    logoHeight: 26,
    metric: "Vendas e financeiro integrados"
}];

function P0({
    t: e
}) {
    return n.jsxs("div", {
        className: "card",
        style: {
            background: s.surface,
            border: `1.5px solid ${s.border}`,
            borderRadius: 18,
            padding: 28,
            display: "flex",
            flexDirection: "column",
            height: "100%",
            minHeight: 380,
            position: "relative",
            overflow: "hidden"
        },
        children: [n.jsx("div", {
            style: {
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: 4,
                background: `linear-gradient(90deg, ${s.accent}, ${s.primary})`
            }
        }), n.jsxs("div", {
            style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 20,
                minHeight: 36
            },
            children: [n.jsx("span", {
                "aria-hidden": !0,
                style: {
                    fontFamily: "Georgia, serif",
                    fontSize: 56,
                    lineHeight: .7,
                    fontWeight: 700,
                    color: s.accent,
                    opacity: .18,
                    userSelect: "none"
                },
                children: "“"
            }), e.logo ? n.jsx("img", {
                src: e.logo,
                alt: e.company,
                style: {
                    height: Math.round(Math.min(e.logoHeight || 32, 34) * 1.35),
                    width: "auto",
                    maxWidth: 138,
                    objectFit: "contain"
                }
            }) : n.jsx("span", {
                style: {
                    fontFamily: p,
                    fontSize: 17,
                    fontWeight: 800,
                    color: s.text,
                    letterSpacing: -.3
                },
                children: e.company
            })]
        }), n.jsx("p", {
            style: {
                fontFamily: p,
                fontSize: 15,
                color: s.text,
                lineHeight: 1.65,
                flex: 1,
                margin: "0 0 16px",
                position: "relative",
                zIndex: 1
            },
            children: e.quote
        }), n.jsx("div", {
            style: {
                display: "flex",
                gap: 3,
                marginBottom: 16
            },
            children: Array.from({
                length: 5
            }).map((t, r) => n.jsx("svg", {
                width: "15",
                height: "15",
                viewBox: "0 0 14 14",
                fill: s.warning,
                children: n.jsx("path", {
                    d: "M7 0L8.65 4.93L13.85 5L9.7 8.1L11.25 13L7 9.95L2.75 13L4.3 8.1L0.15 5L5.35 4.93L7 0Z"
                })
            }, r))
        }), n.jsx("div", {
            style: {
                height: 1,
                background: s.border,
                margin: "0 0 14px"
            }
        }), n.jsx("div", {
            style: {
                display: "flex",
                alignItems: "center",
                gap: 10
            },
            children: n.jsxs("span", {
                style: {
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    fontFamily: p,
                    fontSize: 12.5,
                    fontWeight: 700,
                    color: s.muted
                },
                children: [n.jsxs("svg", {
                    width: "13",
                    height: "13",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: s.accent,
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [n.jsx("path", {
                        d: "M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"
                    }), n.jsx("circle", {
                        cx: "12",
                        cy: "10",
                        r: "2.6"
                    })]
                }), e.uf]
            })
        })]
    })
}

function sl({
    items: e = Ci,
    visible: t = 4,
    gap: r = 20,
    interval: o = 5500
}) {
    const [i, a] = b.useState(0), [l, d] = b.useState(!1), [c, u] = b.useState(t);
    b.useEffect(() => {
        const y = () => {
            const j = window.innerWidth;
            u(j <= 640 ? 1 : j <= 1024 ? 2 : t)
        };
        return y(), window.addEventListener("resize", y), () => window.removeEventListener("resize", y)
    }, [t]);
    const m = Math.max(0, e.length - c);
    b.useEffect(() => {
        a(y => Math.min(y, m))
    }, [m]), b.useEffect(() => {
        if (l || m === 0) return;
        const y = setInterval(() => {
            a(j => j >= m ? 0 : j + 1)
        }, o);
        return () => clearInterval(y)
    }, [l, m, o]);
    const g = y => a(j => {
            const w = j + y;
            return w < 0 ? m : w > m ? 0 : w
        }),
        v = {
            width: 56,
            height: 56,
            borderRadius: "50%",
            background: s.surface,
            border: `1.5px solid ${s.border}`,
            color: s.text,
            fontSize: 30,
            fontWeight: 700,
            lineHeight: 1,
            cursor: "pointer",
            fontFamily: p,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 6px 16px rgba(10,15,30,0.06)",
            transition: "border-color 0.2s, color 0.2s, transform 0.2s"
        };
    return n.jsxs("div", {
        children: [n.jsx("div", {
            onMouseEnter: () => d(!0),
            onMouseLeave: () => d(!1),
            style: {
                overflow: "hidden",
                padding: "4px",
                margin: "-4px"
            },
            children: n.jsx("div", {
                style: {
                    display: "flex",
                    gap: r,
                    transform: `translateX(calc(${-i} * ((100% + ${r}px) / ${c})))`,
                    transition: "transform 0.7s cubic-bezier(.16,1,.3,1)"
                },
                children: e.map((y, j) => n.jsx("div", {
                    style: {
                        flex: `0 0 calc((100% - ${r*(c-1)}px) / ${c})`,
                        minWidth: 0
                    },
                    children: n.jsx(P0, {
                        t: y
                    })
                }, j))
            })
        }), n.jsxs("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 20,
                marginTop: 40
            },
            children: [n.jsx("button", {
                onClick: () => g(-1),
                "aria-label": "Anterior",
                style: v,
                onMouseEnter: y => {
                    y.currentTarget.style.borderColor = s.accent, y.currentTarget.style.color = s.accent
                },
                onMouseLeave: y => {
                    y.currentTarget.style.borderColor = s.border, y.currentTarget.style.color = s.text
                },
                children: "‹"
            }), n.jsx("div", {
                style: {
                    display: "flex",
                    gap: 8,
                    alignItems: "center"
                },
                children: Array.from({
                    length: m + 1
                }).map((y, j) => n.jsx("button", {
                    onClick: () => a(j),
                    "aria-label": `Página ${j+1}`,
                    style: {
                        width: j === i ? 32 : 8,
                        height: 8,
                        borderRadius: 4,
                        background: j === i ? s.accent : s.border,
                        border: "none",
                        cursor: "pointer",
                        padding: 0,
                        transition: "width 0.35s cubic-bezier(.16,1,.3,1), background 0.2s"
                    }
                }, j))
            }), n.jsx("button", {
                onClick: () => g(1),
                "aria-label": "Próximo",
                style: v,
                onMouseEnter: y => {
                    y.currentTarget.style.borderColor = s.accent, y.currentTarget.style.color = s.accent
                },
                onMouseLeave: y => {
                    y.currentTarget.style.borderColor = s.border, y.currentTarget.style.color = s.text
                },
                children: "›"
            })]
        })]
    })
}

// ── Ícones, dados e componente da página (site real) ──────────────────────────
const Ht = {
        handshake: n.jsxs("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            width: "28",
            height: "28",
            children: [n.jsx("path", {
                d: "M11 17l-4-4-1.5 1.5a2.1 2.1 0 0 1-3-3l5-5L11 9l4-4 3 3-3 3-3.5-1L9.5 12 13 15.5l-2 1.5z"
            }), n.jsx("path", {
                d: "M14 14l3 3 1.5-1.5a2.1 2.1 0 0 0-3-3"
            })]
        }),
        user: n.jsxs("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            width: "28",
            height: "28",
            children: [n.jsx("circle", {
                cx: "12",
                cy: "8",
                r: "4"
            }), n.jsx("path", {
                d: "M4 21c0-4 4-6 8-6s8 2 8 6"
            })]
        }),
        building: n.jsxs("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            width: "28",
            height: "28",
            children: [n.jsx("rect", {
                x: "5",
                y: "3",
                width: "14",
                height: "18",
                rx: "1.5"
            }), n.jsx("line", {
                x1: "9",
                y1: "7",
                x2: "9",
                y2: "7.01"
            }), n.jsx("line", {
                x1: "12",
                y1: "7",
                x2: "12",
                y2: "7.01"
            }), n.jsx("line", {
                x1: "15",
                y1: "7",
                x2: "15",
                y2: "7.01"
            }), n.jsx("line", {
                x1: "9",
                y1: "11",
                x2: "9",
                y2: "11.01"
            }), n.jsx("line", {
                x1: "12",
                y1: "11",
                x2: "12",
                y2: "11.01"
            }), n.jsx("line", {
                x1: "15",
                y1: "11",
                x2: "15",
                y2: "11.01"
            }), n.jsx("line", {
                x1: "9",
                y1: "15",
                x2: "9",
                y2: "15.01"
            }), n.jsx("line", {
                x1: "12",
                y1: "15",
                x2: "12",
                y2: "15.01"
            }), n.jsx("line", {
                x1: "15",
                y1: "15",
                x2: "15",
                y2: "15.01"
            }), n.jsx("path", {
                d: "M10 21v-3h4v3"
            })]
        }),
        chart: n.jsxs("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            width: "28",
            height: "28",
            children: [n.jsx("line", {
                x1: "3",
                y1: "21",
                x2: "21",
                y2: "21"
            }), n.jsx("rect", {
                x: "5",
                y: "13",
                width: "3",
                height: "6",
                rx: "0.5"
            }), n.jsx("rect", {
                x: "10.5",
                y: "9",
                width: "3",
                height: "10",
                rx: "0.5"
            }), n.jsx("rect", {
                x: "16",
                y: "5",
                width: "3",
                height: "14",
                rx: "0.5"
            })]
        }),
        doc: n.jsxs("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            width: "28",
            height: "28",
            children: [n.jsx("path", {
                d: "M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"
            }), n.jsx("polyline", {
                points: "14 3 14 8 19 8"
            }), n.jsx("line", {
                x1: "8",
                y1: "13",
                x2: "16",
                y2: "13"
            }), n.jsx("line", {
                x1: "8",
                y1: "17",
                x2: "13",
                y2: "17"
            })]
        }),
        gear: n.jsxs("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            width: "28",
            height: "28",
            children: [n.jsx("circle", {
                cx: "12",
                cy: "12",
                r: "3.2"
            }), n.jsx("path", {
                d: "M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1A1.7 1.7 0 0 0 4.6 9a1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"
            })]
        }),
        rocket: n.jsxs("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "1.6",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            width: "28",
            height: "28",
            children: [n.jsx("path", {
                d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"
            }), n.jsx("path", {
                d: "M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"
            }), n.jsx("path", {
                d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"
            }), n.jsx("path", {
                d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"
            })]
        })
    },
    sa = [{
        num: "01",
        title: "Kick Off",
        desc: "Apresentação do fluxo e início das tratativas da implantação.",
        icon: Ht.handshake
    }, {
        num: "02",
        title: "Gestão CRM",
        desc: "Cadastro de usuários, empreendimentos e gestão do lead.",
        icon: Ht.user
    }, {
        num: "03",
        title: "Gestão do Empreendimento",
        desc: "Cadastro das unidades e complemento das informações.",
        icon: Ht.building
    }, {
        num: "04",
        title: "Gestão de Vendas",
        desc: "Cadastro e configurações das tabelas de venda.",
        icon: Ht.chart
    }, {
        num: "05",
        title: "Documentos Padrões",
        desc: "Configuração e cadastro das minutas — Proposta e Contrato.",
        icon: Ht.doc
    }, {
        num: "06",
        title: "Integrações",
        desc: "Configuração, validação e instrução de utilização da integração.",
        icon: Ht.gear
    }, {
        num: "07",
        title: "Treinamento e Go Live",
        desc: "Treinamento do time interno e gestão de corretores — encerramento da implantação.",
        icon: Ht.rocket
    }],
    fo = [{
        name: "Sienge ERP",
        cat: "ERP",
        logo: "/assets/integ/sienge.png"
    }, {
        name: "UAU Senior",
        cat: "ERP",
        logo: "/assets/integ/uau.png"
    }, {
        name: "TOTVS",
        cat: "ERP",
        logo: "/assets/integ/totvs.png"
    }, {
        name: "Mega ERP",
        cat: "ERP",
        logo: "/assets/integ/mega.png"
    }, {
        name: "HubSpot",
        cat: "Marketing",
        logo: "/assets/integ/hubspot.png"
    }, {
        name: "RD Station",
        cat: "Marketing",
        logo: "/assets/integ/rd-station.png"
    }, {
        name: "Facebook Ads",
        cat: "Marketing",
        logo: "/assets/integ/facebook-ads.png"
    }, {
        name: "Portal ZAP",
        cat: "Portais",
        logo: "/assets/integ/zap.png"
    }, {
        name: "Viva Real",
        cat: "Portais",
        logo: "/assets/integ/viva-real.png"
    }, {
        name: "ImovelWeb",
        cat: "Portais",
        logo: "/assets/integ/imovel-web.png"
    }, {
        name: "ClickSign",
        cat: "Assinatura",
        logo: "/assets/integ/clicksign.png"
    }, {
        name: "DocuSign",
        cat: "Assinatura",
        logo: "/assets/integ/docusign.png"
    }, {
        name: "WhatsApp API",
        cat: "Comunicação",
        logo: "/assets/integ/whatsapp.png"
    }, {
        name: "Bot Conversa",
        cat: "Comunicação",
        logo: "/assets/integ/bot-conversa.png"
    }, {
        name: "Emotion",
        cat: "Comunicação",
        logo: "/assets/integ/emotion.png"
    }, {
        name: "Lais",
        cat: "IA",
        logo: "/assets/integ/lais.png"
    }, {
        name: "Zapier",
        cat: "Automação",
        logo: "/assets/integ/zapier.png"
    }, {
        name: "Webhook",
        cat: "Automação",
        logo: "/assets/integ/webhook.png"
    }, {
        name: "API aberta",
        cat: "Automação",
        logo: "/assets/integ/api.png"
    }],
    _0 = [{
        q: "Quanto tempo leva pra colocar um empreendimento no ar?",
        a: "A implantação completa — mapeamento, cadastro das unidades, tabela de venda, integrações e treinamento — leva em média 4 a 6 semanas."
    }, {
        q: "Funciona pra incorporadoras verticais (apartamentos)?",
        a: "Sim. O CRM tem gestão nativa por torre, andar e tipologia. Você cadastra plantas, áreas privativas, valores diferenciados por andar e regras de bloqueio específicas."
    }, {
        q: "Posso usar o IMOBMEET com o ERP que já uso?",
        a: "Sim. Integração nativa. Cada venda confirmada no IMOBMEET é enviada automaticamente ao ERP, com contrato, comissões e dados financeiros."
    }, {
        q: "É possível personalizar contratos por empreendimento?",
        a: "Sim. Cada empreendimento pode ter seus próprios modelos com variáveis dinâmicas (índice de correção, cláusulas específicas, garantias) e geração automática a partir da proposta aprovada."
    }, {
        q: "Como funciona o atendimento via WhatsApp dentro do CRM?",
        a: "Integramos o WhatsApp Business API ao funil. Cada conversa fica vinculada ao lead, com histórico, distribuição automática por regra e relatórios de SLA por atendente."
    }, {
        q: "O que é um CRM para construtoras?",
        a: "É o sistema que organiza toda a operação comercial de uma construtora — gestão de leads, unidades, reservas, propostas, contratos e recebíveis — em uma só plataforma, integrada ao ERP. O IMOBMEET é um CRM para construtoras completo, da obra à venda e ao contrato assinado."
    }, {
        q: "Qual o melhor CRM para construtoras?",
        a: "O melhor CRM para construtoras é o que une vendas e financeiro em uma plataforma só, com gestão de unidades em tempo real, geração de contratos, assinatura digital e integração com ERPs como Sienge e UAU. O IMOBMEET reúne tudo isso, com implantação acompanhada em 4 a 6 semanas."
    }, {
        q: "Quanto custa um CRM para construtoras?",
        a: "O investimento varia conforme o tamanho da operação, o número de empreendimentos e os módulos contratados (CRM, recebíveis, Autovendas). Agende uma demonstração para receber uma proposta sob medida para a sua construtora."
    }];

function H0({
    logos: e
}) {
    const t = [...e, ...e];
    return n.jsx("div", {
        className: "logo-marquee",
        style: {
            padding: "12px 0"
        },
        children: n.jsx("div", {
            className: "logo-track",
            style: {
                gap: 16
            },
            children: t.map((r, o) => n.jsxs("div", {
                className: "integ-tile",
                style: {
                    flexShrink: 0,
                    width: 120,
                    height: 120,
                    borderRadius: 18,
                    background: s.surface,
                    border: `1.5px solid ${s.border}`,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 16,
                    gap: 6,
                    transition: "transform 0.3s cubic-bezier(.16,1,.3,1), box-shadow 0.3s, border-color 0.3s",
                    cursor: "default"
                },
                children: [n.jsx("img", {
                    src: r.logo,
                    alt: r.name,
                    style: {
                        width: 48,
                        height: 48,
                        objectFit: "contain"
                    }
                }), n.jsx("span", {
                    style: {
                        fontFamily: p,
                        fontSize: 10.5,
                        fontWeight: 700,
                        color: s.muted,
                        letterSpacing: .2,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                        textAlign: "center"
                    },
                    children: r.name
                })]
            }, o))
        })
    })
}
function q0() {
    const [e, t] = b.useState(null), [r, o] = b.useState("Todos"), [i, a] = b.useState(!1), l = "I-pIGzpivQs";
    return [...Array.from(new Set(fo.map(d => d.cat)))], r === "Todos" || fo.filter(d => d.cat === r), n.jsxs("div", {
        style: {
            fontFamily: p,
            color: s.text,
            overflowX: "clip",
            background: s.surface
        },
        children: [n.jsx(_n, {
            activeSolution: "/crm-construtoras"
        }), n.jsxs("section", {
            id: "hero",
            "data-screen-label": "01 Hero",
            style: {
                position: "relative",
                overflow: "hidden",
                minHeight: "min(780px, 94vh)",
                display: "flex",
                alignItems: "center",
                padding: "140px 28px 110px"
            },
            children: [n.jsx("div", {
                className: "hero-bg-zoom",
                style: {
                    position: "absolute",
                    inset: 0,
                    backgroundImage: "url(/assets/crm-para-incorporadoras-imobmeet.jpg)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    pointerEvents: "none"
                }
            }), n.jsx("div", {
                style: {
                    position: "absolute",
                    inset: 0,
                    pointerEvents: "none",
                    background: "linear-gradient(180deg, rgba(8,16,42,0.80) 0%, rgba(8,16,42,0.66) 45%, rgba(8,16,42,0.86) 100%)"
                }
            }), n.jsx("div", {
                style: {
                    position: "absolute",
                    inset: 0,
                    pointerEvents: "none",
                    background: "radial-gradient(ellipse 70% 60% at 50% 45%, transparent 0%, rgba(8,16,42,0.55) 100%)"
                }
            }), n.jsxs("div", {
                style: {
                    position: "relative",
                    zIndex: 3,
                    maxWidth: 820,
                    margin: "0 auto",
                    textAlign: "center"
                },
                children: [n.jsx(k, {
                    children: n.jsxs("div", {
                        style: {
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 12,
                            padding: "10px 29px 10px 11px",
                            marginBottom: 26,
                            background: "#FFFFFF",
                            border: "1px solid rgba(10,15,30,0.08)",
                            borderRadius: 14,
                            boxShadow: "0 10px 28px rgba(8,16,42,0.18)",
                            fontFamily: p,
                            fontSize: 19,
                            fontWeight: 800,
                            color: "rgba(10,15,30,0.8)",
                            letterSpacing: .2
                        },
                        children: [n.jsx("span", {
                            style: {
                                width: 60,
                                height: 60,
                                borderRadius: 15,
                                flexShrink: 0,
                                background: "linear-gradient(135deg, #0560FF, #204493)",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            },
                            children: n.jsxs("svg", {
                                width: "39",
                                height: "39",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "1.8",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [n.jsx("rect", {
                                    x: "5",
                                    y: "3",
                                    width: "14",
                                    height: "18",
                                    rx: "1.5"
                                }), n.jsx("path", {
                                    d: "M9 7h.01M12 7h.01M15 7h.01M9 11h.01M12 11h.01M15 11h.01M9 15h.01M12 15h.01M15 15h.01"
                                }), n.jsx("path", {
                                    d: "M10 21v-3h4v3"
                                })]
                            })
                        }), "CRM para Construtoras"]
                    })
                }), n.jsx(k, {
                    delay: 1,
                    children: n.jsxs("h1", {
                        style: {
                            fontFamily: p,
                            fontSize: "clamp(40px, 6vw, 62px)",
                            fontWeight: 800,
                            lineHeight: 1.04,
                            letterSpacing: -2,
                            color: "white",
                            margin: "0 0 22px",
                            textShadow: "0 2px 30px rgba(8,16,42,0.4)"
                        },
                        children: ["CRM para Construtoras", n.jsx("br", {}), n.jsx("span", {
                            style: {
                                color: "#7FB6FF"
                            },
                            children: "gestão completa em um só lugar"
                        })]
                    })
                }), n.jsx(k, {
                    delay: 2,
                    children: n.jsx("p", {
                        style: {
                            fontFamily: p,
                            fontSize: 19,
                            color: "rgba(255,255,255,0.9)",
                            lineHeight: 1.6,
                            margin: "0 auto 38px",
                            maxWidth: 680
                        },
                        children: "Gestão de leads, reservas, propostas, contratos, análise de crédito, emissão de boletos, integração bancária, gestão de recebíveis e integração com o seu ERP."
                    })
                }), n.jsx(k, {
                    delay: 3,
                    children: n.jsxs("div", {
                        style: {
                            display: "flex",
                            gap: 14,
                            flexWrap: "wrap",
                            justifyContent: "center"
                        },
                        children: [n.jsxs("button", {
                            onClick: () => a(!0),
                            style: {
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 12,
                                padding: "14px 28px 14px 14px",
                                borderRadius: 12,
                                background: "rgba(255,255,255,0.12)",
                                backdropFilter: "blur(8px)",
                                border: "1.5px solid rgba(255,255,255,0.35)",
                                fontFamily: p,
                                fontSize: 16,
                                fontWeight: 700,
                                color: "white",
                                cursor: "pointer",
                                transition: "background 0.2s, transform 0.2s"
                            },
                            onMouseEnter: d => {
                                d.currentTarget.style.background = "rgba(255,255,255,0.2)", d.currentTarget.style.transform = "translateY(-2px)"
                            },
                            onMouseLeave: d => {
                                d.currentTarget.style.background = "rgba(255,255,255,0.12)", d.currentTarget.style.transform = "none"
                            },
                            children: [n.jsx("span", {
                                style: {
                                    width: 40,
                                    height: 40,
                                    borderRadius: "50%",
                                    background: "white",
                                    color: s.accent,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0
                                },
                                children: n.jsx("svg", {
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor",
                                    children: n.jsx("path", {
                                        d: "M8 5v14l11-7z"
                                    })
                                })
                            }), "Assistir Vídeo"]
                        }), n.jsx(se, {
                            to: "/agendar-demo",
                            children: "Fale com vendas"
                        })]
                    })
                })]
            })]
        }), n.jsx("section", {
            style: {
                background: s.surface,
                padding: "44px 0 52px",
                borderTop: `1px solid ${s.border}`,
                borderBottom: `1px solid ${s.border}`
            },
            children: n.jsxs("div", {
                style: {
                    maxWidth: 1280,
                    margin: "0 auto"
                },
                children: [n.jsx(k, {
                    children: n.jsx("p", {
                        style: {
                            textAlign: "center",
                            fontSize: 11,
                            color: s.muted,
                            marginBottom: 28,
                            fontWeight: 700,
                            letterSpacing: 1.6,
                            textTransform: "uppercase"
                        },
                        children: "Incorporadoras e loteadoras que confiam no IMOBMEET"
                    })
                }), n.jsx(ft, {
                    logos: ["/assets/clientes/c01.png", "/assets/clientes/c02.png", "/assets/clientes/c03.png", "/assets/clientes/c05.png", "/assets/clientes/c06.png", "/assets/clientes/c07.png", "/assets/clientes/c08.png", "/assets/clientes/c09.png", "/assets/clientes/c10.png", "/assets/clientes/c11.png", "/assets/clientes/c12.png", "/assets/clientes/c13.png", "/assets/clientes/lfurtado.png", "/assets/clientes/gtg.png", "/assets/clientes/pemi.png", "/assets/clientes/engecom.png", "/assets/brdu.svg"],
                    mono: !1
                })]
            })
        }), n.jsx("section", {
            "data-screen-label": "02 Sistema",
            style: {
                background: s.surface,
                padding: "104px 28px"
            },
            children: n.jsxs("div", {
                style: {
                    maxWidth: 1160,
                    margin: "0 auto"
                },
                children: [n.jsx(k, {
                    children: n.jsxs("div", {
                        style: {
                            textAlign: "center",
                            maxWidth: 720,
                            margin: "0 auto 64px"
                        },
                        children: [n.jsx(O, {
                            style: {
                                marginBottom: 16
                            },
                            children: "Veja o IMOBMEET por dentro"
                        }), n.jsx("p", {
                            style: {
                                fontFamily: p,
                                fontSize: 17.5,
                                color: s.muted,
                                margin: 0,
                                lineHeight: 1.65
                            },
                            children: "Do espelho de vendas à assinatura digital — tudo o que a sua construtora precisa para vender e gerenciar empreendimentos em um só lugar."
                        })]
                    })
                }), [{
                    img: "/assets/sys/gestao-leads.png",
                    eyebrow: "Gestão de Leads",
                    title: "Seu Funil de Gestão de Leads inteligente",
                    text: "Centralize os leads de todos os canais — Facebook, Instagram, portais (ZAP, Viva Real, OLX), WhatsApp e site — em um funil kanban por etapa e responsável. Cada lead chega com origem, produto e responsável, e avança da oportunidade à proposta sem planilha intermediária.",
                    bullets: ["Captação automática de Facebook, ZAP, Viva Real, OLX e WhatsApp", "Distribuição de leads por etapa e responsável", "Histórico, classificação (quente/frio) e SLA de atendimento"]
                }, {
                    img: "/assets/sys/gestao-unidades-vertical.png",
                    eyebrow: "Espelho de Vendas",
                    title: "Gestão de unidades e Disponibilidade em tempo real",
                    text: "Visualize o empreendimento inteiro por torre, andar e tipologia. Cada unidade reflete o status atual — disponível, reservado, vendido ou bloqueado — atualizado em tempo real para todo o time, no desktop e no app.",
                    bullets: ["Visão por torre, andar e tipologia", "Reserva e bloqueio com aprovação automática", "Visão para gestores, corretores e administradores", "Link Público da disponibilidade"]
                }, {
                    img: "/assets/sys/proposta-simulacao.png",
                    eyebrow: "Proposta & Simulação",
                    title: "Proposta e simulação de pagamento em minutos",
                    text: "Configure sua tabela de vendas, monte sua proposta, entrada, parcelas e financiamento, com cálculo automático de percentuais e valores, na versão web ou aplicativo.",
                    bullets: ["Criação de Tabelas e fluxos de pagamento", "Configuração de Juros e Correções", "Criação de Parcelas personalizadas", "Notificação automática no WhatsApp"]
                }, {
                    img: "/assets/sys/assinatura-online.png",
                    eyebrow: "Assinatura Digital",
                    title: "Assinatura digital integrada",
                    text: "Gere o contrato e colete a assinatura com integração nativa às principais plataformas de assinatura digital. O cliente assina pelo celular, na hora — sem reunião presencial e sem papel.",
                    bullets: ["Integração com as principais assinaturas digitais", "Assinatura pelo celular, com validade jurídica", "Contrato vinculado à venda e ao ERP", "Assinatura via WhatsApp"],
                    logos: ["docusign", "clicksign", "zapsign", "d4sign"].map(d => `/assets/sign/${d}.png`)
                }].map((d, c) => n.jsx(k, {
                    delay: 1,
                    children: n.jsxs("div", {
                        className: "feat-row",
                        style: {
                            display: "flex",
                            alignItems: "center",
                            gap: 56,
                            flexWrap: "wrap",
                            marginBottom: c < 3 ? 88 : 0
                        },
                        children: [n.jsx("div", {
                            style: {
                                flex: "1 1 420px",
                                minWidth: 0,
                                order: c % 2 === 0 ? 0 : 1
                            },
                            children: n.jsx("div", {
                                style: {
                                    borderRadius: 18,
                                    overflow: "hidden"
                                },
                                children: n.jsx("img", {
                                    src: d.img,
                                    alt: d.title,
                                    loading: "lazy",
                                    style: {
                                        width: "100%",
                                        display: "block"
                                    }
                                })
                            })
                        }), n.jsxs("div", {
                            style: {
                                flex: "1 1 360px",
                                minWidth: 0,
                                order: c % 2 === 0 ? 1 : 0
                            },
                            children: [n.jsxs("div", {
                                style: {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 10,
                                    fontFamily: p,
                                    fontSize: 15.5,
                                    fontWeight: 800,
                                    letterSpacing: .2,
                                    color: "rgba(10,15,30,0.8)",
                                    background: "#FFFFFF",
                                    border: `1px solid ${s.border}`,
                                    boxShadow: "0 6px 18px rgba(10,15,30,0.08)",
                                    padding: "7px 17px 7px 8px",
                                    borderRadius: 12,
                                    marginBottom: 18
                                },
                                children: [n.jsx("img", {
                                    src: "/assets/icon-imobmeet.png",
                                    alt: "IMOBMEET",
                                    width: "38",
                                    height: "38",
                                    style: {
                                        display: "block",
                                        borderRadius: 10
                                    }
                                }), d.eyebrow]
                            }), n.jsx("h3", {
                                style: {
                                    fontFamily: p,
                                    fontSize: 27,
                                    fontWeight: 800,
                                    letterSpacing: -.6,
                                    color: s.text,
                                    margin: "0 0 14px",
                                    lineHeight: 1.2
                                },
                                children: d.title
                            }), n.jsx("p", {
                                style: {
                                    fontFamily: p,
                                    fontSize: 16.5,
                                    color: s.muted,
                                    lineHeight: 1.65,
                                    margin: "0 0 22px"
                                },
                                children: d.text
                            }), n.jsx("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 12
                                },
                                children: d.bullets.map(u => n.jsxs("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "flex-start",
                                        gap: 11
                                    },
                                    children: [n.jsx("span", {
                                        style: {
                                            width: 22,
                                            height: 22,
                                            borderRadius: "50%",
                                            flexShrink: 0,
                                            marginTop: 1,
                                            background: s.accent,
                                            color: "white",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        },
                                        children: n.jsx("svg", {
                                            width: "12",
                                            height: "12",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "3",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: n.jsx("path", {
                                                d: "M20 6 9 17l-5-5"
                                            })
                                        })
                                    }), n.jsx("span", {
                                        style: {
                                            fontFamily: p,
                                            fontSize: 15.5,
                                            color: s.text,
                                            lineHeight: 1.5
                                        },
                                        children: u
                                    })]
                                }, u))
                            }), d.logos && n.jsx("div", {
                                style: {
                                    marginTop: 26,
                                    borderRadius: 14,
                                    border: `1px solid ${s.border}`,
                                    background: "#FFFFFF",
                                    padding: "16px 0",
                                    overflow: "hidden"
                                },
                                children: n.jsx(ft, {
                                    logos: d.logos,
                                    mono: !1,
                                    height: 30,
                                    gap: 44
                                })
                            })]
                        })]
                    })
                }, d.title))]
            })
        }), n.jsx("section", {
            style: {
                background: s.surface,
                padding: "100px 28px",
                borderTop: `1px solid ${s.border}`
            },
            children: n.jsxs("div", {
                style: {
                    maxWidth: 1080,
                    margin: "0 auto"
                },
                children: [n.jsxs("div", {
                    className: "bank-header",
                    style: {
                        display: "grid",
                        gridTemplateColumns: "0.78fr 1.22fr",
                        gap: 56,
                        alignItems: "center",
                        margin: "0 auto 56px"
                    },
                    children: [n.jsx(k, {
                        children: n.jsxs("div", {
                            style: {
                                position: "relative",
                                maxWidth: 340,
                                margin: "0 auto"
                            },
                            children: [n.jsx(Si, {
                                src: "/assets/people/gestor-recebiveis-mobile.jpg",
                                alt: "Gestor acompanhando os recebíveis no IMOBMEET",
                                ratio: "4 / 5",
                                radius: 26
                            }), n.jsxs("div", {
                                style: {
                                    position: "absolute",
                                    bottom: -20,
                                    right: -18,
                                    background: "white",
                                    borderRadius: 16,
                                    padding: "13px 16px",
                                    boxShadow: "0 18px 44px rgba(15,32,66,0.16)",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 11
                                },
                                children: [n.jsx("div", {
                                    style: {
                                        width: 40,
                                        height: 40,
                                        borderRadius: 11,
                                        flexShrink: 0,
                                        background: "rgba(16,185,129,0.14)",
                                        color: "#10B981",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: n.jsx("svg", {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2.2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: n.jsx("path", {
                                            d: "M20 6 9 17l-5-5"
                                        })
                                    })
                                }), n.jsxs("div", {
                                    children: [n.jsx("div", {
                                        style: {
                                            fontFamily: p,
                                            fontWeight: 800,
                                            fontSize: 14.5,
                                            color: s.text
                                        },
                                        children: "Boleto conciliado"
                                    }), n.jsx("div", {
                                        style: {
                                            fontFamily: p,
                                            fontSize: 12,
                                            color: s.muted
                                        },
                                        children: "automático, em tempo real"
                                    })]
                                })]
                            })]
                        })
                    }), n.jsx(k, {
                        delay: 1,
                        children: n.jsxs("div", {
                            children: [n.jsx(O, {
                                style: {
                                    marginBottom: 16
                                },
                                children: "Gestão de Recebíveis completa integrada ao seu banco."
                            }), n.jsx("p", {
                                style: {
                                    fontFamily: p,
                                    fontSize: 17.5,
                                    color: s.muted,
                                    margin: "0 0 28px",
                                    lineHeight: 1.65,
                                    maxWidth: 520
                                },
                                children: "Emissão de boletos unitários ou em lote, conciliação automática sem a necessidade de arquivos de remessa, retorno ou conciliação — integrado nativamente aos principais bancos que a sua operação já usa."
                            }), n.jsxs("button", {
                                onClick: () => a(!0),
                                style: {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 12,
                                    padding: "13px 26px 13px 13px",
                                    borderRadius: 11,
                                    background: s.surface,
                                    border: `1.5px solid ${s.border}`,
                                    fontFamily: p,
                                    fontSize: 15.5,
                                    fontWeight: 700,
                                    color: s.text,
                                    cursor: "pointer",
                                    transition: "border-color 0.2s, transform 0.2s, box-shadow 0.2s"
                                },
                                onMouseEnter: d => {
                                    d.currentTarget.style.borderColor = s.accent, d.currentTarget.style.transform = "translateY(-2px)", d.currentTarget.style.boxShadow = "0 10px 28px rgba(5,96,255,0.12)"
                                },
                                onMouseLeave: d => {
                                    d.currentTarget.style.borderColor = s.border, d.currentTarget.style.transform = "none", d.currentTarget.style.boxShadow = "none"
                                },
                                children: [n.jsx("span", {
                                    style: {
                                        width: 38,
                                        height: 38,
                                        borderRadius: "50%",
                                        background: s.accent,
                                        color: "white",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexShrink: 0
                                    },
                                    children: n.jsx("svg", {
                                        width: "15",
                                        height: "15",
                                        viewBox: "0 0 24 24",
                                        fill: "currentColor",
                                        children: n.jsx("path", {
                                            d: "M8 5v14l11-7z"
                                        })
                                    })
                                }), "Assistir Vídeo"]
                            })]
                        })
                    })]
                }), n.jsx("div", {
                    style: {
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                        gap: 16
                    },
                    children: [{
                        name: "Itaú",
                        src: "/assets/banks/itau.png"
                    }, {
                        name: "Bradesco",
                        src: "/assets/banks/bradesco.png"
                    }, {
                        name: "Santander",
                        src: "/assets/banks/santander.png"
                    }, {
                        name: "BTG Pactual",
                        src: "/assets/banks/btg.svg"
                    }, {
                        name: "Caixa",
                        src: "/assets/banks/caixa.png"
                    }, {
                        name: "Banco BRB",
                        src: "/assets/banks/brb.png"
                    }, {
                        name: "Banco Inter",
                        src: "/assets/banks/inter.svg",
                        maxH: 62
                    }, {
                        name: "Banco Safra",
                        src: "/assets/banks/safra.png"
                    }, {
                        name: "Sicredi",
                        src: "/assets/banks/sicredi.png"
                    }, {
                        name: "Sicoob",
                        src: "/assets/banks/sicoob.png"
                    }].map((d, c) => n.jsx(k, {
                        delay: c % 6 + 1,
                        children: n.jsx("div", {
                            className: "card",
                            style: {
                                background: s.surface,
                                border: `1px solid ${s.border}`,
                                borderRadius: 16,
                                padding: "24px 22px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: 96
                            },
                            children: n.jsx("img", {
                                src: d.src,
                                alt: d.name,
                                title: d.name,
                                loading: "lazy",
                                style: {
                                    maxHeight: d.maxH || 40,
                                    maxWidth: "100%",
                                    width: "auto",
                                    objectFit: "contain",
                                    display: "block"
                                }
                            })
                        })
                    }, d.name))
                }), n.jsx(k, {
                    children: n.jsx("p", {
                        style: {
                            textAlign: "center",
                            fontFamily: p,
                            fontSize: 15.5,
                            fontWeight: 600,
                            color: s.muted,
                            margin: "30px 0 0"
                        },
                        children: "São mais de 30 bancos disponíveis."
                    })
                }), n.jsx(k, {
                    children: n.jsxs("div", {
                        style: {
                            marginTop: 76
                        },
                        children: [n.jsx("div", {
                            style: {
                                textAlign: "center",
                                marginBottom: 44
                            },
                            children: n.jsx("h3", {
                                style: {
                                    fontFamily: p,
                                    fontSize: 27,
                                    fontWeight: 800,
                                    letterSpacing: -.7,
                                    color: s.text,
                                    margin: "12px 0 0"
                                },
                                children: "Do boleto à baixa, sem trabalho manual"
                            })
                        }), n.jsxs("div", {
                            className: "recv2-timeline",
                            style: {
                                position: "relative",
                                display: "flex",
                                justifyContent: "space-between",
                                gap: 8,
                                maxWidth: 980,
                                margin: "0 auto"
                            },
                            children: [n.jsx("div", {
                                className: "recv2-line"
                            }), [{
                                label: "Boleto Automático",
                                desc: "Emissão de boletos no automático.",
                                icon: n.jsxs(n.Fragment, {
                                    children: [n.jsx("rect", {
                                        x: "3",
                                        y: "5",
                                        width: "18",
                                        height: "14",
                                        rx: "2"
                                    }), n.jsx("path", {
                                        d: "M7 9v6M10 9v6M13 9v6M16 9v6"
                                    })]
                                })
                            }, {
                                label: "Correção automática",
                                desc: "Juros e índices atualizados sozinhos.",
                                icon: n.jsxs(n.Fragment, {
                                    children: [n.jsx("path", {
                                        d: "M21 12a9 9 0 1 1-3-6.7"
                                    }), n.jsx("path", {
                                        d: "M21 4v5h-5"
                                    })]
                                })
                            }, {
                                label: "Régua de Cobrança",
                                desc: "Lembretes no WhatsApp e e-mail.",
                                icon: n.jsxs(n.Fragment, {
                                    children: [n.jsx("path", {
                                        d: "M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"
                                    }), n.jsx("path", {
                                        d: "M13.7 21a2 2 0 0 1-3.4 0"
                                    })]
                                })
                            }, {
                                label: "Baixa Automática",
                                desc: "Conciliação sem remessa manual.",
                                icon: n.jsxs(n.Fragment, {
                                    children: [n.jsx("path", {
                                        d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
                                    }), n.jsx("path", {
                                        d: "M22 4 12 14.01l-3-3"
                                    })]
                                })
                            }, {
                                label: "Dashboard ao vivo",
                                desc: "Indicadores de recebíveis em tempo real.",
                                icon: n.jsxs(n.Fragment, {
                                    children: [n.jsx("rect", {
                                        x: "3",
                                        y: "3",
                                        width: "18",
                                        height: "18",
                                        rx: "2"
                                    }), n.jsx("path", {
                                        d: "M7 15v-4M12 15V9M17 15v-6"
                                    })]
                                })
                            }].map((d, c) => n.jsxs("div", {
                                style: {
                                    position: "relative",
                                    zIndex: 1,
                                    flex: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    textAlign: "center",
                                    padding: "0 4px"
                                },
                                children: [n.jsxs("div", {
                                    className: "recv2-node",
                                    style: {
                                        position: "relative",
                                        width: 62,
                                        height: 62,
                                        borderRadius: "50%",
                                        flexShrink: 0,
                                        background: "linear-gradient(135deg, #0560FF, #204493)",
                                        color: "white",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginBottom: 16,
                                        boxShadow: "0 12px 26px rgba(5,96,255,0.30)",
                                        animation: `flow-pop 0.5s ease ${.15+c*.12}s both`
                                    },
                                    children: [n.jsx("svg", {
                                        width: "26",
                                        height: "26",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "1.9",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: d.icon
                                    }), n.jsx("span", {
                                        style: {
                                            position: "absolute",
                                            top: -5,
                                            right: -5,
                                            width: 23,
                                            height: 23,
                                            borderRadius: "50%",
                                            background: "white",
                                            color: s.accent,
                                            border: `2px solid ${s.accent}`,
                                            fontFamily: p,
                                            fontSize: 11,
                                            fontWeight: 800,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        },
                                        children: c + 1
                                    })]
                                }), n.jsx("div", {
                                    style: {
                                        fontFamily: p,
                                        fontSize: 14.5,
                                        fontWeight: 800,
                                        color: s.text,
                                        lineHeight: 1.3,
                                        maxWidth: 150
                                    },
                                    children: d.label
                                }), n.jsx("div", {
                                    style: {
                                        fontFamily: p,
                                        fontSize: 12.5,
                                        color: s.muted,
                                        lineHeight: 1.45,
                                        marginTop: 5,
                                        maxWidth: 160
                                    },
                                    children: d.desc
                                })]
                            }, d.label))]
                        })]
                    })
                }), n.jsx(k, {
                    delay: 1,
                    children: n.jsx("div", {
                        style: {
                            textAlign: "center",
                            marginTop: 48
                        },
                        children: n.jsx(se, {
                            to: "/agendar-demo",
                            children: "Agendar demonstração"
                        })
                    })
                })]
            })
        }), n.jsx(al, {}), n.jsxs("section", {
            id: "integracoes",
            "data-screen-label": "06 Integrações",
            style: {
                background: s.surface,
                padding: "112px 28px",
                position: "relative",
                overflow: "hidden"
            },
            children: [n.jsx("div", {
                style: {
                    position: "absolute",
                    left: -120,
                    top: 80,
                    width: 360,
                    height: 360,
                    borderRadius: "50%",
                    background: "radial-gradient(circle, rgba(5,96,255,0.07), transparent 70%)",
                    pointerEvents: "none"
                }
            }), n.jsxs("div", {
                style: {
                    maxWidth: 1280,
                    margin: "0 auto",
                    position: "relative"
                },
                children: [n.jsx(k, {
                    children: n.jsxs("div", {
                        style: {
                            textAlign: "center",
                            marginBottom: 64
                        },
                        children: [n.jsxs(O, {
                            style: {
                                marginBottom: 18
                            },
                            children: ["CRM conectado ao seu ERP", n.jsx("br", {}), "e a todos os seus canais de Marketing."]
                        }), n.jsx("p", {
                            style: {
                                fontFamily: p,
                                fontSize: 17,
                                color: s.muted,
                                maxWidth: 620,
                                margin: "0 auto",
                                lineHeight: 1.6
                            },
                            children: "Sienge, UAU, Informakon e outros ERPs recebem vendas, contratos e comissões automaticamente. Leads chegam direto dos seus portais e campanhas de marketing — sem planilha intermediária."
                        })]
                    })
                }), n.jsx(k, {
                    delay: 1,
                    children: n.jsx(H0, {
                        logos: fo
                    })
                })]
            })]
        }), n.jsxs("section", {
            id: "timeline",
            "data-screen-label": "05 Implantação",
            style: {
                background: s.bgAlt,
                padding: "112px 28px 120px",
                position: "relative",
                overflow: "hidden"
            },
            children: [n.jsx("div", {
                style: {
                    position: "absolute",
                    top: -100,
                    right: -120,
                    width: 360,
                    height: 360,
                    borderRadius: "50%",
                    background: "radial-gradient(circle, rgba(5,96,255,0.08), transparent 70%)",
                    pointerEvents: "none"
                }
            }), n.jsxs("div", {
                style: {
                    maxWidth: 1320,
                    margin: "0 auto"
                },
                children: [n.jsx(k, {
                    children: n.jsxs("div", {
                        style: {
                            textAlign: "center",
                            marginBottom: 72
                        },
                        children: [n.jsx(O, {
                            style: {
                                marginBottom: 16
                            },
                            children: "Implantação estruturada, em 7 etapas"
                        }), n.jsx("p", {
                            style: {
                                fontFamily: p,
                                fontSize: 17,
                                color: s.muted,
                                maxWidth: 580,
                                margin: "0 auto",
                                lineHeight: 1.6
                            },
                            children: "Onboarding guiado por equipe especializada — do kick off ao go live, com cada etapa documentada e validada com o seu time."
                        })]
                    })
                }), n.jsx("div", {
                    className: "timeline-grid",
                    style: {
                        display: "grid",
                        gridTemplateColumns: "repeat(7, 1fr)",
                        gap: 10,
                        position: "relative"
                    },
                    children: sa.map((d, c) => {
                        const u = c / (sa.length - 1),
                            m = `linear-gradient(165deg,
                color-mix(in oklab, ${s.accent} ${20+u*70}%, white) 0%,
                color-mix(in oklab, ${s.primary} ${15+u*80}%, ${s.accent}) 100%)`,
                            g = u < .25 ? s.primary : "white";
                        return n.jsx(k, {
                            delay: Math.min(c + 1, 6),
                            children: n.jsxs("div", {
                                style: {
                                    position: "relative",
                                    height: "100%"
                                },
                                children: [c < sa.length - 1 && n.jsx("div", {
                                    className: "timeline-arrow",
                                    style: {
                                        position: "absolute",
                                        right: -10,
                                        top: 64,
                                        width: 14,
                                        height: 14,
                                        zIndex: 2,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        pointerEvents: "none"
                                    },
                                    children: n.jsx("svg", {
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: s.accent,
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: n.jsx("polyline", {
                                            points: "9 6 15 12 9 18"
                                        })
                                    })
                                }), n.jsxs("div", {
                                    className: "card",
                                    style: {
                                        background: s.surface,
                                        borderRadius: 14,
                                        overflow: "hidden",
                                        border: `1.5px solid ${s.border}`,
                                        boxShadow: "0 8px 24px rgba(10,15,30,0.05)",
                                        height: "100%",
                                        display: "flex",
                                        flexDirection: "column"
                                    },
                                    children: [n.jsxs("div", {
                                        style: {
                                            background: m,
                                            padding: "26px 14px 22px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: g,
                                            position: "relative",
                                            overflow: "hidden"
                                        },
                                        children: [n.jsx("div", {
                                            style: {
                                                position: "absolute",
                                                top: -20,
                                                right: -20,
                                                width: 80,
                                                height: 80,
                                                borderRadius: "50%",
                                                background: "radial-gradient(circle, rgba(255,255,255,0.20) 0%, transparent 60%)"
                                            }
                                        }), n.jsx("div", {
                                            style: {
                                                position: "absolute",
                                                top: 10,
                                                left: 14,
                                                zIndex: 1,
                                                fontFamily: p,
                                                fontSize: 14,
                                                fontWeight: 800,
                                                letterSpacing: .5,
                                                color: g,
                                                opacity: .85
                                            },
                                            children: d.num
                                        }), n.jsx("div", {
                                            style: {
                                                position: "relative",
                                                zIndex: 1
                                            },
                                            children: d.icon
                                        })]
                                    }), n.jsxs("div", {
                                        style: {
                                            padding: "20px 16px 22px",
                                            flex: 1,
                                            display: "flex",
                                            flexDirection: "column"
                                        },
                                        children: [n.jsx("h3", {
                                            style: {
                                                fontFamily: p,
                                                fontSize: 16,
                                                fontWeight: 800,
                                                color: s.text,
                                                margin: "0 0 12px",
                                                lineHeight: 1.25,
                                                letterSpacing: -.3,
                                                minHeight: 40
                                            },
                                            children: d.title
                                        }), n.jsx("p", {
                                            style: {
                                                fontFamily: p,
                                                fontSize: 12.5,
                                                color: s.muted,
                                                lineHeight: 1.55,
                                                margin: 0
                                            },
                                            children: d.desc
                                        })]
                                    })]
                                })]
                            })
                        }, d.num)
                    })
                }), n.jsx(k, {
                    delay: 2,
                    children: n.jsx("div", {
                        style: {
                            textAlign: "center",
                            marginTop: 56
                        },
                        children: n.jsx(se, {
                            to: "/agendar-demo",
                            children: "Agendar demonstração"
                        })
                    })
                })]
            })]
        }), n.jsx("section", {
            id: "depoimentos",
            "data-screen-label": "07 Depoimentos",
            style: {
                background: s.bgAlt,
                padding: "112px 28px"
            },
            children: n.jsxs("div", {
                style: {
                    maxWidth: 1180,
                    margin: "0 auto"
                },
                children: [n.jsx(k, {
                    children: n.jsx("div", {
                        style: {
                            textAlign: "center",
                            marginBottom: 64
                        },
                        children: n.jsx(O, {
                            children: "Quem usa, recomenda"
                        })
                    })
                }), n.jsx(k, {
                    delay: 1,
                    children: n.jsx(sl, {
                        items: Ci,
                        visible: 4
                    })
                })]
            })
        }), n.jsx("section", {
            id: "faq",
            "data-screen-label": "08 FAQ",
            style: {
                background: s.surface,
                padding: "112px 28px"
            },
            children: n.jsxs("div", {
                style: {
                    maxWidth: 820,
                    margin: "0 auto"
                },
                children: [n.jsx(k, {
                    children: n.jsx("div", {
                        style: {
                            textAlign: "center",
                            marginBottom: 56
                        },
                        children: n.jsx(O, {
                            children: "Perguntas frequentes"
                        })
                    })
                }), _0.map((d, c) => n.jsx(k, {
                    delay: Math.min(c + 1, 5),
                    children: n.jsxs("div", {
                        className: `faq-item ${e===c?"open":""}`,
                        style: {
                            background: e === c ? s.bgAlt : s.surface,
                            border: `1.5px solid ${e===c?s.accentBorder:s.border}`,
                            borderRadius: 14,
                            marginBottom: 12,
                            overflow: "hidden",
                            transition: "background 0.25s, border-color 0.25s"
                        },
                        children: [n.jsxs("button", {
                            onClick: () => t(e === c ? null : c),
                            style: {
                                width: "100%",
                                textAlign: "left",
                                padding: "22px 26px",
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: 16,
                                fontFamily: p
                            },
                            children: [n.jsx("span", {
                                style: {
                                    fontFamily: p,
                                    fontSize: 16,
                                    fontWeight: 700,
                                    color: s.text,
                                    lineHeight: 1.4
                                },
                                children: d.q
                            }), n.jsx("span", {
                                className: "faq-icon",
                                style: {
                                    width: 32,
                                    height: 32,
                                    borderRadius: 8,
                                    flexShrink: 0,
                                    background: e === c ? s.accent : s.accentLight,
                                    color: e === c ? "white" : s.accent,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: 18,
                                    fontWeight: 700,
                                    transition: "background 0.25s, color 0.25s"
                                },
                                children: "+"
                            })]
                        }), n.jsx("div", {
                            className: "faq-body",
                            children: n.jsx("div", {
                                children: n.jsx("div", {
                                    style: {
                                        padding: "0 26px 24px",
                                        fontFamily: p,
                                        fontSize: 15,
                                        color: s.muted,
                                        lineHeight: 1.7
                                    },
                                    children: d.a
                                })
                            })
                        })]
                    })
                }, c))]
            })
        }), n.jsxs("section", {
            id: "demo",
            "data-screen-label": "09 CTA",
            style: {
                background: `linear-gradient(135deg, ${s.primary} 0%, #2A5BC8 60%, ${s.accent} 100%)`,
                padding: "120px 28px",
                position: "relative",
                overflow: "hidden"
            },
            children: [n.jsx("div", {
                className: "grid-bg-dark",
                style: {
                    position: "absolute",
                    inset: 0,
                    opacity: .5
                }
            }), n.jsx("div", {
                className: "drift-soft",
                style: {
                    position: "absolute",
                    left: "-10%",
                    top: "-30%",
                    width: 500,
                    height: 500,
                    borderRadius: "50%",
                    background: "radial-gradient(circle, rgba(255,255,255,0.10), transparent 70%)",
                    pointerEvents: "none"
                }
            }), n.jsx("div", {
                className: "drift-soft",
                style: {
                    position: "absolute",
                    right: "-10%",
                    bottom: "-30%",
                    width: 500,
                    height: 500,
                    borderRadius: "50%",
                    background: "radial-gradient(circle, rgba(5,96,255,0.20), transparent 70%)",
                    pointerEvents: "none",
                    animationDelay: "2s"
                }
            }), n.jsxs("div", {
                style: {
                    maxWidth: 820,
                    margin: "0 auto",
                    textAlign: "center",
                    position: "relative"
                },
                children: [n.jsx(k, {}), n.jsx(k, {
                    delay: 1,
                    children: n.jsxs("h2", {
                        style: {
                            fontFamily: p,
                            fontSize: 52,
                            fontWeight: 800,
                            color: "white",
                            margin: "0 0 22px",
                            lineHeight: 1.05,
                            letterSpacing: -1.8
                        },
                        children: ["Pronto para centralizar a operação", n.jsx("br", {}), "da sua construtora no IMOBMEET?"]
                    })
                }), n.jsx(k, {
                    delay: 2,
                    children: n.jsx("p", {
                        style: {
                            fontFamily: p,
                            fontSize: 18,
                            color: "rgba(255,255,255,0.78)",
                            marginBottom: 40,
                            lineHeight: 1.6
                        },
                        children: "Agende uma demonstração e veja como o IMOBMEET funciona na prática."
                    })
                }), n.jsx(k, {
                    delay: 3,
                    children: n.jsxs("div", {
                        style: {
                            display: "flex",
                            gap: 14,
                            justifyContent: "center",
                            flexWrap: "wrap"
                        },
                        children: [n.jsx(V, {
                            to: "/agendar-demo",
                            className: "cta-primary",
                            style: {
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 8,
                                background: "white",
                                color: s.primary,
                                padding: "18px 36px",
                                borderRadius: 12,
                                fontFamily: p,
                                fontSize: 16,
                                fontWeight: 800,
                                textDecoration: "none",
                                position: "relative",
                                overflow: "hidden",
                                boxShadow: "0 14px 32px rgba(0,0,0,0.18)"
                            },
                            children: n.jsxs("span", {
                                style: {
                                    position: "relative",
                                    zIndex: 1,
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 8
                                },
                                children: ["Agendar demonstração ", n.jsx("span", {
                                    className: "arrow",
                                    children: "→"
                                })]
                            })
                        }), n.jsx(V, {
                            to: "/agendar-demo",
                            style: {
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 8,
                                background: "transparent",
                                color: "white",
                                padding: "18px 36px",
                                borderRadius: 12,
                                fontFamily: p,
                                fontSize: 16,
                                fontWeight: 700,
                                textDecoration: "none",
                                border: "1.5px solid rgba(255,255,255,0.35)",
                                transition: "background 0.2s, border-color 0.2s"
                            },
                            onMouseEnter: d => {
                                d.currentTarget.style.background = "rgba(255,255,255,0.08)", d.currentTarget.style.borderColor = "white"
                            },
                            onMouseLeave: d => {
                                d.currentTarget.style.background = "transparent", d.currentTarget.style.borderColor = "rgba(255,255,255,0.35)"
                            },
                            children: "Falar com vendas"
                        })]
                    })
                })]
            })]
        }), n.jsx(ki, {
            open: i,
            onClose: () => a(!1),
            videoId: l,
            title: "IMOBMEET em ação"
        }), n.jsx(Hn, {}), n.jsx(qn, {})]
    })
}

// ── Página CRM para Incorporadoras ───────────────────────────────────────────
export default function CrmConstrutoras() {
    b.useEffect(() => {
        applySeo({
            title: "CRM para Construtoras: Gestão Completa de Vendas | IMOBMEET",
            description: "CRM para construtoras: gestão de leads, propostas, contratos digitais, boletos, recebíveis e integração com ERP. Da obra à venda em uma só plataforma.",
            keywords: "CRM para construtoras, software para construtoras, gestão de vendas construtora, CRM imobiliário, gestão de obras e vendas, integração Sienge UAU",
            path: "/crm-construtoras"
        });
        setFaqSchema(_0);
        window.scrollTo(0, 0);
        return () => clearFaqSchema();
    }, []);
    return q0()
}
